/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { BulkAssignOrganizationsRequest } from '../models/bulkAssignOrganizationsRequest';

import type { BulkContactRelationshipRequest } from '../models/bulkContactRelationshipRequest';

import type { BulkContactRelationshipSummaryRequest } from '../models/bulkContactRelationshipSummaryRequest';

import type { BulkContactRequest } from '../models/bulkContactRequest';

import type { BulkOrganizationRelationshipRequest } from '../models/bulkOrganizationRelationshipRequest';

import type { BulkOrganizationRelationshipSummaryRequest } from '../models/bulkOrganizationRelationshipSummaryRequest';

import type { BulkOrganizationRequest } from '../models/bulkOrganizationRequest';

import type { BulkRelationshipResponse } from '../models/bulkRelationshipResponse';

import type { BulkRelationshipSummaryResponse } from '../models/bulkRelationshipSummaryResponse';

import type { CadencePolicyDeleteResult } from '../models/cadencePolicyDeleteResult';

import type { CadencePolicyListResponse } from '../models/cadencePolicyListResponse';

import type { CadencePolicyResponse } from '../models/cadencePolicyResponse';

import type { CadencePolicyUpsert } from '../models/cadencePolicyUpsert';

import type { CadenceResolutionResponse } from '../models/cadenceResolutionResponse';

import type { CascadeRelationshipRequest } from '../models/cascadeRelationshipRequest';

import type { CascadeRelationshipResponse } from '../models/cascadeRelationshipResponse';

import type { CheckDomainRequest } from '../models/checkDomainRequest';

import type { CompanyLookupEnvelope } from '../models/companyLookupEnvelope';

import type { CompanyLookupRequest } from '../models/companyLookupRequest';

import type { ContactCreateRequest } from '../models/contactCreateRequest';

import type { ContactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGetParams } from '../models/contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGetParams';

import type { ContactEnrichmentRequest } from '../models/contactEnrichmentRequest';

import type { ContactUpdateRequest } from '../models/contactUpdateRequest';

import type { DeletionImpact } from '../models/deletionImpact';

import type { DomainEnrichmentRequest } from '../models/domainEnrichmentRequest';

import type { EngagementSummaryResponse } from '../models/engagementSummaryResponse';

import type { EngagementValuesApiV1MasterDataContactsEngagementValuesGetParams } from '../models/engagementValuesApiV1MasterDataContactsEngagementValuesGetParams';

import type { EngagementValuesResponse } from '../models/engagementValuesResponse';

import type { FuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGetParams } from '../models/fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGetParams';

import type { GetContactApiV1MasterDataContactsPeopleContactIdGetParams } from '../models/getContactApiV1MasterDataContactsPeopleContactIdGetParams';

import type { GetOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGetParams } from '../models/getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGetParams';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { ListContactsApiV1MasterDataContactsPeopleGetParams } from '../models/listContactsApiV1MasterDataContactsPeopleGetParams';

import type { ListMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGetParams } from '../models/listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGetParams';

import type { ListOrganizationsApiV1MasterDataContactsOrganizationsGetParams } from '../models/listOrganizationsApiV1MasterDataContactsOrganizationsGetParams';

import type { ListRelationshipClassesApiV1MasterDataContactsRelationshipClassesGetParams } from '../models/listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGetParams';

import type { ListTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGetParams } from '../models/listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGetParams';

import type { MasterDataDuplicateCheckRequest } from '../models/masterDataDuplicateCheckRequest';

import type { MasterDataDuplicateCheckResponse } from '../models/masterDataDuplicateCheckResponse';

import type { MatchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGetParams } from '../models/matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGetParams';

import type { OrganizationCreateRequest } from '../models/organizationCreateRequest';

import type { OrganizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGetParams } from '../models/organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGetParams';

import type { OrganizationUpdateRequest } from '../models/organizationUpdateRequest';

import type { RelationshipClassCarrierCountListResponse } from '../models/relationshipClassCarrierCountListResponse';

import type { RelationshipClassCreateRequest } from '../models/relationshipClassCreateRequest';

import type { RelationshipClassUpdateRequest } from '../models/relationshipClassUpdateRequest';

import type { RelationshipMutationResponse } from '../models/relationshipMutationResponse';

import type { ResolveCadenceApiV1MasterDataContactsCadenceResolveGetParams } from '../models/resolveCadenceApiV1MasterDataContactsCadenceResolveGetParams';

import type { TagConversionPreviewResponse } from '../models/tagConversionPreviewResponse';

import type { TagConversionRequest } from '../models/tagConversionRequest';

import type { TagConversionResponse } from '../models/tagConversionResponse';

import type { TierCreateRequest } from '../models/tierCreateRequest';

import type { TierUpdateRequest } from '../models/tierUpdateRequest';

import type { UserCadencePolicyListResponse } from '../models/userCadencePolicyListResponse';

import type { UserCadencePolicyResponse } from '../models/userCadencePolicyResponse';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * Preflight the tiered duplicate check for a contact/organization form.

Read-only mirror of the check the create/update routes run, so the form can
warn *before* the user hits Save instead of bouncing them off a 409. Returns
``{"data": null}`` when the record looks new.

A ``blocking`` tier means the save WILL be rejected; ``warning`` means it will
succeed and queue a review row. ``match_type`` names the identity signal that
matched and is a closed set — ``email``, ``phone``, ``domain``, ``name``,
``name_country``. The authoritative copy of that set is
``shared/schemas/master_data/duplicate_check.schema.json``, pinned to the
identity contracts by ``test_duplicate_check_match_type_contract.py``.
The tier is always reported, because it is
what tells the user whether Save will work — but ``entity_id``/``entity_label``
are ``null`` unless the caller may actually see that record
(:func:`_duplicate_disclosure_gate`). Under a restricted visibility mode this
endpoint would otherwise be a probe straight past ``get_scope``: guess an
email, learn whose it is.

The TIER, however, is still an existence signal — "is this email/phone/name
already in this tenant?" — with no side effect to audit. That is inherent to
warning a user pre-save and is accepted by design, so the enumeration risk is
bounded by volume instead: a per-HUMAN cap
(:data:`DUPLICATE_CHECK_RATE_LIMIT_PER_MINUTE`), keyed on the human rather
than the IP because every caller here is authenticated and one tenant's users
routinely share an office egress address. Full reasoning:
``duplicate_check_service`` § "Existence disclosure".
 * @summary Check Duplicate
 */
export const checkDuplicateApiV1MasterDataContactsDuplicateCheckPost = (
  masterDataDuplicateCheckRequest: MasterDataDuplicateCheckRequest,
  signal?: AbortSignal
) => {
  return customInstance<MasterDataDuplicateCheckResponse>({
    url: `/api/v1/master-data/contacts/duplicate-check`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: masterDataDuplicateCheckRequest,
    signal
  });
};

export const getCheckDuplicateApiV1MasterDataContactsDuplicateCheckPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof checkDuplicateApiV1MasterDataContactsDuplicateCheckPost
        >
      >,
      TError,
      { data: MasterDataDuplicateCheckRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof checkDuplicateApiV1MasterDataContactsDuplicateCheckPost>
    >,
    TError,
    { data: MasterDataDuplicateCheckRequest },
    TContext
  > => {
    const mutationKey = [
      'checkDuplicateApiV1MasterDataContactsDuplicateCheckPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof checkDuplicateApiV1MasterDataContactsDuplicateCheckPost
        >
      >,
      { data: MasterDataDuplicateCheckRequest }
    > = (props) => {
      const { data } = props ?? {};

      return checkDuplicateApiV1MasterDataContactsDuplicateCheckPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CheckDuplicateApiV1MasterDataContactsDuplicateCheckPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof checkDuplicateApiV1MasterDataContactsDuplicateCheckPost>
    >
  >;
export type CheckDuplicateApiV1MasterDataContactsDuplicateCheckPostMutationBody =
  MasterDataDuplicateCheckRequest;
export type CheckDuplicateApiV1MasterDataContactsDuplicateCheckPostMutationError =
  HTTPValidationError;

/**
 * @summary Check Duplicate
 */
export const useCheckDuplicateApiV1MasterDataContactsDuplicateCheckPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof checkDuplicateApiV1MasterDataContactsDuplicateCheckPost
        >
      >,
      TError,
      { data: MasterDataDuplicateCheckRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof checkDuplicateApiV1MasterDataContactsDuplicateCheckPost>
  >,
  TError,
  { data: MasterDataDuplicateCheckRequest },
  TContext
> => {
  const mutationOptions =
    getCheckDuplicateApiV1MasterDataContactsDuplicateCheckPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List companies with filtering and pagination.
 * @summary List Organizations
 */
export const listOrganizationsApiV1MasterDataContactsOrganizationsGet = (
  params?: ListOrganizationsApiV1MasterDataContactsOrganizationsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/contacts/organizations`,
    method: 'GET',
    params,
    signal
  });
};

export const getListOrganizationsApiV1MasterDataContactsOrganizationsGetQueryKey =
  (params?: ListOrganizationsApiV1MasterDataContactsOrganizationsGetParams) => {
    return [
      `/api/v1/master-data/contacts/organizations`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListOrganizationsApiV1MasterDataContactsOrganizationsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listOrganizationsApiV1MasterDataContactsOrganizationsGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListOrganizationsApiV1MasterDataContactsOrganizationsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listOrganizationsApiV1MasterDataContactsOrganizationsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListOrganizationsApiV1MasterDataContactsOrganizationsGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listOrganizationsApiV1MasterDataContactsOrganizationsGet
        >
      >
    > = ({ signal }) =>
      listOrganizationsApiV1MasterDataContactsOrganizationsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listOrganizationsApiV1MasterDataContactsOrganizationsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListOrganizationsApiV1MasterDataContactsOrganizationsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listOrganizationsApiV1MasterDataContactsOrganizationsGet
      >
    >
  >;
export type ListOrganizationsApiV1MasterDataContactsOrganizationsGetQueryError =
  HTTPValidationError;

export function useListOrganizationsApiV1MasterDataContactsOrganizationsGet<
  TData = Awaited<
    ReturnType<typeof listOrganizationsApiV1MasterDataContactsOrganizationsGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListOrganizationsApiV1MasterDataContactsOrganizationsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOrganizationsApiV1MasterDataContactsOrganizationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listOrganizationsApiV1MasterDataContactsOrganizationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listOrganizationsApiV1MasterDataContactsOrganizationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListOrganizationsApiV1MasterDataContactsOrganizationsGet<
  TData = Awaited<
    ReturnType<typeof listOrganizationsApiV1MasterDataContactsOrganizationsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListOrganizationsApiV1MasterDataContactsOrganizationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOrganizationsApiV1MasterDataContactsOrganizationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listOrganizationsApiV1MasterDataContactsOrganizationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listOrganizationsApiV1MasterDataContactsOrganizationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListOrganizationsApiV1MasterDataContactsOrganizationsGet<
  TData = Awaited<
    ReturnType<typeof listOrganizationsApiV1MasterDataContactsOrganizationsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListOrganizationsApiV1MasterDataContactsOrganizationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOrganizationsApiV1MasterDataContactsOrganizationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Organizations
 */

export function useListOrganizationsApiV1MasterDataContactsOrganizationsGet<
  TData = Awaited<
    ReturnType<typeof listOrganizationsApiV1MasterDataContactsOrganizationsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListOrganizationsApiV1MasterDataContactsOrganizationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOrganizationsApiV1MasterDataContactsOrganizationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListOrganizationsApiV1MasterDataContactsOrganizationsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new company.
 * @summary Create Organization
 */
export const createOrganizationApiV1MasterDataContactsOrganizationsPost = (
  organizationCreateRequest: OrganizationCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/contacts/organizations`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: organizationCreateRequest,
    signal
  });
};

export const getCreateOrganizationApiV1MasterDataContactsOrganizationsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createOrganizationApiV1MasterDataContactsOrganizationsPost
        >
      >,
      TError,
      { data: OrganizationCreateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createOrganizationApiV1MasterDataContactsOrganizationsPost
      >
    >,
    TError,
    { data: OrganizationCreateRequest },
    TContext
  > => {
    const mutationKey = [
      'createOrganizationApiV1MasterDataContactsOrganizationsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createOrganizationApiV1MasterDataContactsOrganizationsPost
        >
      >,
      { data: OrganizationCreateRequest }
    > = (props) => {
      const { data } = props ?? {};

      return createOrganizationApiV1MasterDataContactsOrganizationsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateOrganizationApiV1MasterDataContactsOrganizationsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createOrganizationApiV1MasterDataContactsOrganizationsPost
      >
    >
  >;
export type CreateOrganizationApiV1MasterDataContactsOrganizationsPostMutationBody =
  OrganizationCreateRequest;
export type CreateOrganizationApiV1MasterDataContactsOrganizationsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Organization
 */
export const useCreateOrganizationApiV1MasterDataContactsOrganizationsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createOrganizationApiV1MasterDataContactsOrganizationsPost
        >
      >,
      TError,
      { data: OrganizationCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof createOrganizationApiV1MasterDataContactsOrganizationsPost
    >
  >,
  TError,
  { data: OrganizationCreateRequest },
  TContext
> => {
  const mutationOptions =
    getCreateOrganizationApiV1MasterDataContactsOrganizationsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Fuzzy search companies by name and aliases for vendor matching.
 * @summary Fuzzy Search Organizations
 */
export const fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet =
  (
    params: FuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/organizations/fuzzy-search`,
      method: 'GET',
      params,
      signal
    });
  };

export const getFuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGetQueryKey =
  (
    params?: FuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGetParams
  ) => {
    return [
      `/api/v1/master-data/contacts/organizations/fuzzy-search`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getFuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: FuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getFuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet
        >
      >
    > = ({ signal }) =>
      fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type FuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet
      >
    >
  >;
export type FuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGetQueryError =
  HTTPValidationError;

export function useFuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet<
  TData = Awaited<
    ReturnType<
      typeof fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet
    >
  >,
  TError = HTTPValidationError
>(
  params: FuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useFuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet<
  TData = Awaited<
    ReturnType<
      typeof fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet
    >
  >,
  TError = HTTPValidationError
>(
  params: FuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useFuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet<
  TData = Awaited<
    ReturnType<
      typeof fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet
    >
  >,
  TError = HTTPValidationError
>(
  params: FuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Fuzzy Search Organizations
 */

export function useFuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet<
  TData = Awaited<
    ReturnType<
      typeof fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet
    >
  >,
  TError = HTTPValidationError
>(
  params: FuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof fuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getFuzzySearchOrganizationsApiV1MasterDataContactsOrganizationsFuzzySearchGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List distinct industries.
 * @summary List Industries
 */
export const listIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/contacts/organizations/industries`,
    method: 'GET',
    signal
  });
};

export const getListIndustriesApiV1MasterDataContactsOrganizationsIndustriesGetQueryKey =
  () => {
    return [`/api/v1/master-data/contacts/organizations/industries`] as const;
  };

export const getListIndustriesApiV1MasterDataContactsOrganizationsIndustriesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListIndustriesApiV1MasterDataContactsOrganizationsIndustriesGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet
        >
      >
    > = ({ signal }) =>
      listIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListIndustriesApiV1MasterDataContactsOrganizationsIndustriesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet
      >
    >
  >;
export type ListIndustriesApiV1MasterDataContactsOrganizationsIndustriesGetQueryError =
  unknown;

export function useListIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet<
  TData = Awaited<
    ReturnType<
      typeof listIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet<
  TData = Awaited<
    ReturnType<
      typeof listIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet<
  TData = Awaited<
    ReturnType<
      typeof listIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Industries
 */

export function useListIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet<
  TData = Awaited<
    ReturnType<
      typeof listIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listIndustriesApiV1MasterDataContactsOrganizationsIndustriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListIndustriesApiV1MasterDataContactsOrganizationsIndustriesGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Suggest an organization matching an email/website domain.

Given ``fred@acme.com`` or ``acme.com``, returns the organization whose
``domain`` or ``website`` host matches, so the contact create flow can
suggest attaching it. Returns ``{"data": null}`` when there is no match.
 * @summary Match Organization By Domain
 */
export const matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet =
  (
    params: MatchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/organizations/match-domain`,
      method: 'GET',
      params,
      signal
    });
  };

export const getMatchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGetQueryKey =
  (
    params?: MatchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGetParams
  ) => {
    return [
      `/api/v1/master-data/contacts/organizations/match-domain`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getMatchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: MatchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getMatchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet
        >
      >
    > = ({ signal }) =>
      matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type MatchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet
      >
    >
  >;
export type MatchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGetQueryError =
  HTTPValidationError;

export function useMatchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet<
  TData = Awaited<
    ReturnType<
      typeof matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet
    >
  >,
  TError = HTTPValidationError
>(
  params: MatchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useMatchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet<
  TData = Awaited<
    ReturnType<
      typeof matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet
    >
  >,
  TError = HTTPValidationError
>(
  params: MatchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMatchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet<
  TData = Awaited<
    ReturnType<
      typeof matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet
    >
  >,
  TError = HTTPValidationError
>(
  params: MatchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Match Organization By Domain
 */

export function useMatchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet<
  TData = Awaited<
    ReturnType<
      typeof matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet
    >
  >,
  TError = HTTPValidationError
>(
  params: MatchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof matchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getMatchOrganizationByDomainApiV1MasterDataContactsOrganizationsMatchDomainGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a company by ID.
 * @summary Get Organization
 */
export const getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet =
  (
    organizationId: string,
    params?: GetOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/organizations/${organizationId}`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGetQueryKey =
  (
    organizationId?: string,
    params?: GetOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGetParams
  ) => {
    return [
      `/api/v1/master-data/contacts/organizations/${organizationId}`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    organizationId: string,
    params?: GetOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGetQueryKey(
        organizationId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet
        >
      >
    > = ({ signal }) =>
      getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet(
        organizationId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!organizationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet
      >
    >
  >;
export type GetOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGetQueryError =
  HTTPValidationError;

export function useGetOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  params:
    | undefined
    | GetOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  params?: GetOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  params?: GetOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Organization
 */

export function useGetOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  params?: GetOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdGetQueryOptions(
      organizationId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a company.
 * @summary Update Organization
 */
export const updateOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdPut =
  (
    organizationId: string,
    organizationUpdateRequest: OrganizationUpdateRequest
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/organizations/${organizationId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: organizationUpdateRequest
    });
  };

export const getUpdateOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdPut
        >
      >,
      TError,
      { organizationId: string; data: OrganizationUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdPut
      >
    >,
    TError,
    { organizationId: string; data: OrganizationUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updateOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdPut
        >
      >,
      { organizationId: string; data: OrganizationUpdateRequest }
    > = (props) => {
      const { organizationId, data } = props ?? {};

      return updateOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdPut(
        organizationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdPut
      >
    >
  >;
export type UpdateOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdPutMutationBody =
  OrganizationUpdateRequest;
export type UpdateOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Organization
 */
export const useUpdateOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdPut
          >
        >,
        TError,
        { organizationId: string; data: OrganizationUpdateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdPut
      >
    >,
    TError,
    { organizationId: string; data: OrganizationUpdateRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a company (soft delete), refused while a live record depends on it.
 * @summary Delete Organization
 */
export const deleteOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdDelete =
  (organizationId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/organizations/${organizationId}`,
      method: 'DELETE'
    });
  };

export const getDeleteOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdDelete
        >
      >,
      TError,
      { organizationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdDelete
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdDelete
        >
      >,
      { organizationId: string }
    > = (props) => {
      const { organizationId } = props ?? {};

      return deleteOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdDelete(
        organizationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdDelete
      >
    >
  >;

export type DeleteOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Organization
 */
export const useDeleteOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdDelete
          >
        >,
        TError,
        { organizationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdDelete
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Cascade organization_relationship changes to associated contacts.
 * @summary Cascade Relationship To Contacts
 */
export const cascadeRelationshipToContactsApiV1MasterDataContactsOrganizationsOrganizationIdCascadeRelationshipPut =
  (
    organizationId: string,
    cascadeRelationshipRequest: CascadeRelationshipRequest
  ) => {
    return customInstance<CascadeRelationshipResponse>({
      url: `/api/v1/master-data/contacts/organizations/${organizationId}/cascade-relationship`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: cascadeRelationshipRequest
    });
  };

export const getCascadeRelationshipToContactsApiV1MasterDataContactsOrganizationsOrganizationIdCascadeRelationshipPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof cascadeRelationshipToContactsApiV1MasterDataContactsOrganizationsOrganizationIdCascadeRelationshipPut
        >
      >,
      TError,
      { organizationId: string; data: CascadeRelationshipRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof cascadeRelationshipToContactsApiV1MasterDataContactsOrganizationsOrganizationIdCascadeRelationshipPut
      >
    >,
    TError,
    { organizationId: string; data: CascadeRelationshipRequest },
    TContext
  > => {
    const mutationKey = [
      'cascadeRelationshipToContactsApiV1MasterDataContactsOrganizationsOrganizationIdCascadeRelationshipPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof cascadeRelationshipToContactsApiV1MasterDataContactsOrganizationsOrganizationIdCascadeRelationshipPut
        >
      >,
      { organizationId: string; data: CascadeRelationshipRequest }
    > = (props) => {
      const { organizationId, data } = props ?? {};

      return cascadeRelationshipToContactsApiV1MasterDataContactsOrganizationsOrganizationIdCascadeRelationshipPut(
        organizationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CascadeRelationshipToContactsApiV1MasterDataContactsOrganizationsOrganizationIdCascadeRelationshipPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof cascadeRelationshipToContactsApiV1MasterDataContactsOrganizationsOrganizationIdCascadeRelationshipPut
      >
    >
  >;
export type CascadeRelationshipToContactsApiV1MasterDataContactsOrganizationsOrganizationIdCascadeRelationshipPutMutationBody =
  CascadeRelationshipRequest;
export type CascadeRelationshipToContactsApiV1MasterDataContactsOrganizationsOrganizationIdCascadeRelationshipPutMutationError =
  HTTPValidationError;

/**
 * @summary Cascade Relationship To Contacts
 */
export const useCascadeRelationshipToContactsApiV1MasterDataContactsOrganizationsOrganizationIdCascadeRelationshipPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof cascadeRelationshipToContactsApiV1MasterDataContactsOrganizationsOrganizationIdCascadeRelationshipPut
          >
        >,
        TError,
        { organizationId: string; data: CascadeRelationshipRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof cascadeRelationshipToContactsApiV1MasterDataContactsOrganizationsOrganizationIdCascadeRelationshipPut
      >
    >,
    TError,
    { organizationId: string; data: CascadeRelationshipRequest },
    TContext
  > => {
    const mutationOptions =
      getCascadeRelationshipToContactsApiV1MasterDataContactsOrganizationsOrganizationIdCascadeRelationshipPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Archive a company.
 * @summary Archive Organization
 */
export const archiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdArchivePost =
  (organizationId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/organizations/${organizationId}/archive`,
      method: 'POST',
      signal
    });
  };

export const getArchiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdArchivePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof archiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdArchivePost
        >
      >,
      TError,
      { organizationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof archiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdArchivePost
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationKey = [
      'archiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdArchivePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof archiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdArchivePost
        >
      >,
      { organizationId: string }
    > = (props) => {
      const { organizationId } = props ?? {};

      return archiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdArchivePost(
        organizationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ArchiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdArchivePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof archiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdArchivePost
      >
    >
  >;

export type ArchiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdArchivePostMutationError =
  HTTPValidationError;

/**
 * @summary Archive Organization
 */
export const useArchiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdArchivePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof archiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdArchivePost
          >
        >,
        TError,
        { organizationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof archiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdArchivePost
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationOptions =
      getArchiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdArchivePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Unarchive a company.
 * @summary Unarchive Organization
 */
export const unarchiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdUnarchivePost =
  (organizationId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/organizations/${organizationId}/unarchive`,
      method: 'POST',
      signal
    });
  };

export const getUnarchiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdUnarchivePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unarchiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdUnarchivePost
        >
      >,
      TError,
      { organizationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof unarchiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdUnarchivePost
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationKey = [
      'unarchiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdUnarchivePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof unarchiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdUnarchivePost
        >
      >,
      { organizationId: string }
    > = (props) => {
      const { organizationId } = props ?? {};

      return unarchiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdUnarchivePost(
        organizationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnarchiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdUnarchivePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof unarchiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdUnarchivePost
      >
    >
  >;

export type UnarchiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdUnarchivePostMutationError =
  HTTPValidationError;

/**
 * @summary Unarchive Organization
 */
export const useUnarchiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdUnarchivePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof unarchiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdUnarchivePost
          >
        >,
        TError,
        { organizationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof unarchiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdUnarchivePost
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationOptions =
      getUnarchiveOrganizationApiV1MasterDataContactsOrganizationsOrganizationIdUnarchivePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Deletion-impact preview for a company (deletion-and-cascade-design §5.1).

Read-only; called when the delete dialog opens. A VIEWER floor, not the
EDITOR the DELETE itself needs: the preview reports counts about records the
caller may not see, and the naming rule that governs THAT is enforced inside
the providers (tenant-wide counts, caller-scoped samples), not by this gate.
 * @summary Get Organization Deletion Impact
 */
export const getOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet =
  (organizationId: string, signal?: AbortSignal) => {
    return customInstance<DeletionImpact>({
      url: `/api/v1/master-data/contacts/organizations/${organizationId}/deletion-impact`,
      method: 'GET',
      signal
    });
  };

export const getGetOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGetQueryKey =
  (organizationId?: string) => {
    return [
      `/api/v1/master-data/contacts/organizations/${organizationId}/deletion-impact`
    ] as const;
  };

export const getGetOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet
      >
    >,
    TError = HTTPValidationError
  >(
    organizationId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGetQueryKey(
        organizationId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet
        >
      >
    > = ({ signal }) =>
      getOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet(
        organizationId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!organizationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet
      >
    >
  >;
export type GetOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGetQueryError =
  HTTPValidationError;

export function useGetOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Organization Deletion Impact
 */

export function useGetOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetOrganizationDeletionImpactApiV1MasterDataContactsOrganizationsOrganizationIdDeletionImpactGetQueryOptions(
      organizationId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Bulk delete companies — the loaded ids, or every row matching the filters.

Partial, like its contacts twin: companies a live record still depends on are
kept and named, the rest are deleted.
 * @summary Bulk Delete Organizations
 */
export const bulkDeleteOrganizationsApiV1MasterDataContactsOrganizationsBulkDeletePost =
  (bulkOrganizationRequest: BulkOrganizationRequest, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/organizations/bulk-delete`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: bulkOrganizationRequest,
      signal
    });
  };

export const getBulkDeleteOrganizationsApiV1MasterDataContactsOrganizationsBulkDeletePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkDeleteOrganizationsApiV1MasterDataContactsOrganizationsBulkDeletePost
        >
      >,
      TError,
      { data: BulkOrganizationRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkDeleteOrganizationsApiV1MasterDataContactsOrganizationsBulkDeletePost
      >
    >,
    TError,
    { data: BulkOrganizationRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkDeleteOrganizationsApiV1MasterDataContactsOrganizationsBulkDeletePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkDeleteOrganizationsApiV1MasterDataContactsOrganizationsBulkDeletePost
        >
      >,
      { data: BulkOrganizationRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkDeleteOrganizationsApiV1MasterDataContactsOrganizationsBulkDeletePost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkDeleteOrganizationsApiV1MasterDataContactsOrganizationsBulkDeletePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkDeleteOrganizationsApiV1MasterDataContactsOrganizationsBulkDeletePost
      >
    >
  >;
export type BulkDeleteOrganizationsApiV1MasterDataContactsOrganizationsBulkDeletePostMutationBody =
  BulkOrganizationRequest;
export type BulkDeleteOrganizationsApiV1MasterDataContactsOrganizationsBulkDeletePostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Delete Organizations
 */
export const useBulkDeleteOrganizationsApiV1MasterDataContactsOrganizationsBulkDeletePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof bulkDeleteOrganizationsApiV1MasterDataContactsOrganizationsBulkDeletePost
          >
        >,
        TError,
        { data: BulkOrganizationRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof bulkDeleteOrganizationsApiV1MasterDataContactsOrganizationsBulkDeletePost
      >
    >,
    TError,
    { data: BulkOrganizationRequest },
    TContext
  > => {
    const mutationOptions =
      getBulkDeleteOrganizationsApiV1MasterDataContactsOrganizationsBulkDeletePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Bulk archive companies — the loaded ids, or every row matching the filters.
 * @summary Bulk Archive Organizations
 */
export const bulkArchiveOrganizationsApiV1MasterDataContactsOrganizationsBulkArchivePost =
  (bulkOrganizationRequest: BulkOrganizationRequest, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/organizations/bulk-archive`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: bulkOrganizationRequest,
      signal
    });
  };

export const getBulkArchiveOrganizationsApiV1MasterDataContactsOrganizationsBulkArchivePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkArchiveOrganizationsApiV1MasterDataContactsOrganizationsBulkArchivePost
        >
      >,
      TError,
      { data: BulkOrganizationRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkArchiveOrganizationsApiV1MasterDataContactsOrganizationsBulkArchivePost
      >
    >,
    TError,
    { data: BulkOrganizationRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkArchiveOrganizationsApiV1MasterDataContactsOrganizationsBulkArchivePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkArchiveOrganizationsApiV1MasterDataContactsOrganizationsBulkArchivePost
        >
      >,
      { data: BulkOrganizationRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkArchiveOrganizationsApiV1MasterDataContactsOrganizationsBulkArchivePost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkArchiveOrganizationsApiV1MasterDataContactsOrganizationsBulkArchivePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkArchiveOrganizationsApiV1MasterDataContactsOrganizationsBulkArchivePost
      >
    >
  >;
export type BulkArchiveOrganizationsApiV1MasterDataContactsOrganizationsBulkArchivePostMutationBody =
  BulkOrganizationRequest;
export type BulkArchiveOrganizationsApiV1MasterDataContactsOrganizationsBulkArchivePostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Archive Organizations
 */
export const useBulkArchiveOrganizationsApiV1MasterDataContactsOrganizationsBulkArchivePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof bulkArchiveOrganizationsApiV1MasterDataContactsOrganizationsBulkArchivePost
          >
        >,
        TError,
        { data: BulkOrganizationRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof bulkArchiveOrganizationsApiV1MasterDataContactsOrganizationsBulkArchivePost
      >
    >,
    TError,
    { data: BulkOrganizationRequest },
    TContext
  > => {
    const mutationOptions =
      getBulkArchiveOrganizationsApiV1MasterDataContactsOrganizationsBulkArchivePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * How many of the selected organizations carry each relationship / class.
 * @summary Bulk Organization Relationship Summary
 */
export const bulkOrganizationRelationshipSummaryApiV1MasterDataContactsOrganizationsBulkRelationshipSummaryPost =
  (
    bulkOrganizationRelationshipSummaryRequest: BulkOrganizationRelationshipSummaryRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<BulkRelationshipSummaryResponse>({
      url: `/api/v1/master-data/contacts/organizations/bulk-relationship/summary`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: bulkOrganizationRelationshipSummaryRequest,
      signal
    });
  };

export const getBulkOrganizationRelationshipSummaryApiV1MasterDataContactsOrganizationsBulkRelationshipSummaryPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkOrganizationRelationshipSummaryApiV1MasterDataContactsOrganizationsBulkRelationshipSummaryPost
        >
      >,
      TError,
      { data: BulkOrganizationRelationshipSummaryRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkOrganizationRelationshipSummaryApiV1MasterDataContactsOrganizationsBulkRelationshipSummaryPost
      >
    >,
    TError,
    { data: BulkOrganizationRelationshipSummaryRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkOrganizationRelationshipSummaryApiV1MasterDataContactsOrganizationsBulkRelationshipSummaryPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkOrganizationRelationshipSummaryApiV1MasterDataContactsOrganizationsBulkRelationshipSummaryPost
        >
      >,
      { data: BulkOrganizationRelationshipSummaryRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkOrganizationRelationshipSummaryApiV1MasterDataContactsOrganizationsBulkRelationshipSummaryPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkOrganizationRelationshipSummaryApiV1MasterDataContactsOrganizationsBulkRelationshipSummaryPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkOrganizationRelationshipSummaryApiV1MasterDataContactsOrganizationsBulkRelationshipSummaryPost
      >
    >
  >;
export type BulkOrganizationRelationshipSummaryApiV1MasterDataContactsOrganizationsBulkRelationshipSummaryPostMutationBody =
  BulkOrganizationRelationshipSummaryRequest;
export type BulkOrganizationRelationshipSummaryApiV1MasterDataContactsOrganizationsBulkRelationshipSummaryPostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Organization Relationship Summary
 */
export const useBulkOrganizationRelationshipSummaryApiV1MasterDataContactsOrganizationsBulkRelationshipSummaryPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof bulkOrganizationRelationshipSummaryApiV1MasterDataContactsOrganizationsBulkRelationshipSummaryPost
          >
        >,
        TError,
        { data: BulkOrganizationRelationshipSummaryRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof bulkOrganizationRelationshipSummaryApiV1MasterDataContactsOrganizationsBulkRelationshipSummaryPost
      >
    >,
    TError,
    { data: BulkOrganizationRelationshipSummaryRequest },
    TContext
  > => {
    const mutationOptions =
      getBulkOrganizationRelationshipSummaryApiV1MasterDataContactsOrganizationsBulkRelationshipSummaryPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * How many of the selected contacts carry each relationship / class.
 * @summary Bulk Contact Relationship Summary
 */
export const bulkContactRelationshipSummaryApiV1MasterDataContactsPeopleBulkRelationshipSummaryPost =
  (
    bulkContactRelationshipSummaryRequest: BulkContactRelationshipSummaryRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<BulkRelationshipSummaryResponse>({
      url: `/api/v1/master-data/contacts/people/bulk-relationship/summary`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: bulkContactRelationshipSummaryRequest,
      signal
    });
  };

export const getBulkContactRelationshipSummaryApiV1MasterDataContactsPeopleBulkRelationshipSummaryPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkContactRelationshipSummaryApiV1MasterDataContactsPeopleBulkRelationshipSummaryPost
        >
      >,
      TError,
      { data: BulkContactRelationshipSummaryRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkContactRelationshipSummaryApiV1MasterDataContactsPeopleBulkRelationshipSummaryPost
      >
    >,
    TError,
    { data: BulkContactRelationshipSummaryRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkContactRelationshipSummaryApiV1MasterDataContactsPeopleBulkRelationshipSummaryPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkContactRelationshipSummaryApiV1MasterDataContactsPeopleBulkRelationshipSummaryPost
        >
      >,
      { data: BulkContactRelationshipSummaryRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkContactRelationshipSummaryApiV1MasterDataContactsPeopleBulkRelationshipSummaryPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkContactRelationshipSummaryApiV1MasterDataContactsPeopleBulkRelationshipSummaryPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkContactRelationshipSummaryApiV1MasterDataContactsPeopleBulkRelationshipSummaryPost
      >
    >
  >;
export type BulkContactRelationshipSummaryApiV1MasterDataContactsPeopleBulkRelationshipSummaryPostMutationBody =
  BulkContactRelationshipSummaryRequest;
export type BulkContactRelationshipSummaryApiV1MasterDataContactsPeopleBulkRelationshipSummaryPostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Contact Relationship Summary
 */
export const useBulkContactRelationshipSummaryApiV1MasterDataContactsPeopleBulkRelationshipSummaryPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof bulkContactRelationshipSummaryApiV1MasterDataContactsPeopleBulkRelationshipSummaryPost
          >
        >,
        TError,
        { data: BulkContactRelationshipSummaryRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof bulkContactRelationshipSummaryApiV1MasterDataContactsPeopleBulkRelationshipSummaryPost
      >
    >,
    TError,
    { data: BulkContactRelationshipSummaryRequest },
    TContext
  > => {
    const mutationOptions =
      getBulkContactRelationshipSummaryApiV1MasterDataContactsPeopleBulkRelationshipSummaryPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Add and/or remove relationship values and relationship classes on many organizations.

Both directions are explicit: only the values named in the add and remove
lists move, so a value the caller does not mention is untouched. Naming one in
both is refused rather than resolved.

``match_all_filtered`` resolves the SAME filtered query the list page renders
(``build_organization_list_filters``) to a bounded id set, then hands it to
the same set-based service method the id path uses — so the two cannot drift
and the audit trail is identical. Bounded by ``BULK_MATCHING_MAX_AFFECTED``;
over that the call is refused rather than truncated.
 * @summary Bulk Add Organization Relationship
 */
export const bulkAddOrganizationRelationshipApiV1MasterDataContactsOrganizationsBulkRelationshipPost =
  (
    bulkOrganizationRelationshipRequest: BulkOrganizationRelationshipRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<BulkRelationshipResponse>({
      url: `/api/v1/master-data/contacts/organizations/bulk-relationship`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: bulkOrganizationRelationshipRequest,
      signal
    });
  };

export const getBulkAddOrganizationRelationshipApiV1MasterDataContactsOrganizationsBulkRelationshipPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkAddOrganizationRelationshipApiV1MasterDataContactsOrganizationsBulkRelationshipPost
        >
      >,
      TError,
      { data: BulkOrganizationRelationshipRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkAddOrganizationRelationshipApiV1MasterDataContactsOrganizationsBulkRelationshipPost
      >
    >,
    TError,
    { data: BulkOrganizationRelationshipRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkAddOrganizationRelationshipApiV1MasterDataContactsOrganizationsBulkRelationshipPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkAddOrganizationRelationshipApiV1MasterDataContactsOrganizationsBulkRelationshipPost
        >
      >,
      { data: BulkOrganizationRelationshipRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkAddOrganizationRelationshipApiV1MasterDataContactsOrganizationsBulkRelationshipPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkAddOrganizationRelationshipApiV1MasterDataContactsOrganizationsBulkRelationshipPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkAddOrganizationRelationshipApiV1MasterDataContactsOrganizationsBulkRelationshipPost
      >
    >
  >;
export type BulkAddOrganizationRelationshipApiV1MasterDataContactsOrganizationsBulkRelationshipPostMutationBody =
  BulkOrganizationRelationshipRequest;
export type BulkAddOrganizationRelationshipApiV1MasterDataContactsOrganizationsBulkRelationshipPostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Add Organization Relationship
 */
export const useBulkAddOrganizationRelationshipApiV1MasterDataContactsOrganizationsBulkRelationshipPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof bulkAddOrganizationRelationshipApiV1MasterDataContactsOrganizationsBulkRelationshipPost
          >
        >,
        TError,
        { data: BulkOrganizationRelationshipRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof bulkAddOrganizationRelationshipApiV1MasterDataContactsOrganizationsBulkRelationshipPost
      >
    >,
    TError,
    { data: BulkOrganizationRelationshipRequest },
    TContext
  > => {
    const mutationOptions =
      getBulkAddOrganizationRelationshipApiV1MasterDataContactsOrganizationsBulkRelationshipPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Add and/or remove relationship values and relationship classes on many contacts.

Both directions are explicit: only the values named in the add and remove
lists move, so a value the caller does not mention is untouched. Naming one in
both is refused rather than resolved.

``match_all_filtered`` resolves the SAME filtered query the list page renders
(``build_contact_list_filters``) to a bounded id set, then hands it to the
same set-based service method the id path uses — so the two cannot drift and
the audit trail is identical. Bounded by ``BULK_MATCHING_MAX_AFFECTED``; over
that the call is refused rather than truncated.
 * @summary Bulk Add Contact Relationship
 */
export const bulkAddContactRelationshipApiV1MasterDataContactsPeopleBulkRelationshipPost =
  (
    bulkContactRelationshipRequest: BulkContactRelationshipRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<BulkRelationshipResponse>({
      url: `/api/v1/master-data/contacts/people/bulk-relationship`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: bulkContactRelationshipRequest,
      signal
    });
  };

export const getBulkAddContactRelationshipApiV1MasterDataContactsPeopleBulkRelationshipPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkAddContactRelationshipApiV1MasterDataContactsPeopleBulkRelationshipPost
        >
      >,
      TError,
      { data: BulkContactRelationshipRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkAddContactRelationshipApiV1MasterDataContactsPeopleBulkRelationshipPost
      >
    >,
    TError,
    { data: BulkContactRelationshipRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkAddContactRelationshipApiV1MasterDataContactsPeopleBulkRelationshipPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkAddContactRelationshipApiV1MasterDataContactsPeopleBulkRelationshipPost
        >
      >,
      { data: BulkContactRelationshipRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkAddContactRelationshipApiV1MasterDataContactsPeopleBulkRelationshipPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkAddContactRelationshipApiV1MasterDataContactsPeopleBulkRelationshipPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkAddContactRelationshipApiV1MasterDataContactsPeopleBulkRelationshipPost
      >
    >
  >;
export type BulkAddContactRelationshipApiV1MasterDataContactsPeopleBulkRelationshipPostMutationBody =
  BulkContactRelationshipRequest;
export type BulkAddContactRelationshipApiV1MasterDataContactsPeopleBulkRelationshipPostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Add Contact Relationship
 */
export const useBulkAddContactRelationshipApiV1MasterDataContactsPeopleBulkRelationshipPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof bulkAddContactRelationshipApiV1MasterDataContactsPeopleBulkRelationshipPost
          >
        >,
        TError,
        { data: BulkContactRelationshipRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof bulkAddContactRelationshipApiV1MasterDataContactsPeopleBulkRelationshipPost
      >
    >,
    TError,
    { data: BulkContactRelationshipRequest },
    TContext
  > => {
    const mutationOptions =
      getBulkAddContactRelationshipApiV1MasterDataContactsPeopleBulkRelationshipPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * How many records carrying `tag_id` can be converted, and how many cannot.

The dialog renders this before anything is confirmed, so the admin sees the
real blast radius — including the taggable entity types that carry no
relationship dimension and will therefore be left alone.
 * @summary Preview Tag Conversion
 */
export const previewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet =
  (tagId: string, signal?: AbortSignal) => {
    return customInstance<TagConversionPreviewResponse>({
      url: `/api/v1/master-data/contacts/tag-conversion/${tagId}/preview`,
      method: 'GET',
      signal
    });
  };

export const getPreviewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGetQueryKey =
  (tagId?: string) => {
    return [
      `/api/v1/master-data/contacts/tag-conversion/${tagId}/preview`
    ] as const;
  };

export const getPreviewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof previewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet
      >
    >,
    TError = HTTPValidationError
  >(
    tagId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof previewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getPreviewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGetQueryKey(
        tagId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof previewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet
        >
      >
    > = ({ signal }) =>
      previewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet(
        tagId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!tagId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof previewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type PreviewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof previewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet
      >
    >
  >;
export type PreviewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGetQueryError =
  HTTPValidationError;

export function usePreviewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof previewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  tagId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof previewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof previewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function usePreviewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof previewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  tagId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof previewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof previewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePreviewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof previewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  tagId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Preview Tag Conversion
 */

export function usePreviewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof previewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  tagId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getPreviewTagConversionApiV1MasterDataContactsTagConversionTagIdPreviewGetQueryOptions(
      tagId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Convert every contact/company carrying a tag to a relationship and/or class.

Additive on both classification dimensions, and idempotent: re-running the
same conversion reports zero converted rather than duplicating anything.
 * @summary Convert Tag To Relationship
 */
export const convertTagToRelationshipApiV1MasterDataContactsTagConversionPost =
  (tagConversionRequest: TagConversionRequest, signal?: AbortSignal) => {
    return customInstance<TagConversionResponse>({
      url: `/api/v1/master-data/contacts/tag-conversion`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tagConversionRequest,
      signal
    });
  };

export const getConvertTagToRelationshipApiV1MasterDataContactsTagConversionPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof convertTagToRelationshipApiV1MasterDataContactsTagConversionPost
        >
      >,
      TError,
      { data: TagConversionRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof convertTagToRelationshipApiV1MasterDataContactsTagConversionPost
      >
    >,
    TError,
    { data: TagConversionRequest },
    TContext
  > => {
    const mutationKey = [
      'convertTagToRelationshipApiV1MasterDataContactsTagConversionPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof convertTagToRelationshipApiV1MasterDataContactsTagConversionPost
        >
      >,
      { data: TagConversionRequest }
    > = (props) => {
      const { data } = props ?? {};

      return convertTagToRelationshipApiV1MasterDataContactsTagConversionPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ConvertTagToRelationshipApiV1MasterDataContactsTagConversionPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof convertTagToRelationshipApiV1MasterDataContactsTagConversionPost
      >
    >
  >;
export type ConvertTagToRelationshipApiV1MasterDataContactsTagConversionPostMutationBody =
  TagConversionRequest;
export type ConvertTagToRelationshipApiV1MasterDataContactsTagConversionPostMutationError =
  HTTPValidationError;

/**
 * @summary Convert Tag To Relationship
 */
export const useConvertTagToRelationshipApiV1MasterDataContactsTagConversionPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof convertTagToRelationshipApiV1MasterDataContactsTagConversionPost
          >
        >,
        TError,
        { data: TagConversionRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof convertTagToRelationshipApiV1MasterDataContactsTagConversionPost
      >
    >,
    TError,
    { data: TagConversionRequest },
    TContext
  > => {
    const mutationOptions =
      getConvertTagToRelationshipApiV1MasterDataContactsTagConversionPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List all customer tiers.
 * @summary List Tiers
 */
export const listTiersApiV1MasterDataContactsTiersGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/contacts/tiers`,
    method: 'GET',
    signal
  });
};

export const getListTiersApiV1MasterDataContactsTiersGetQueryKey = () => {
  return [`/api/v1/master-data/contacts/tiers`] as const;
};

export const getListTiersApiV1MasterDataContactsTiersGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listTiersApiV1MasterDataContactsTiersGet>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listTiersApiV1MasterDataContactsTiersGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListTiersApiV1MasterDataContactsTiersGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTiersApiV1MasterDataContactsTiersGet>>
  > = ({ signal }) => listTiersApiV1MasterDataContactsTiersGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTiersApiV1MasterDataContactsTiersGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListTiersApiV1MasterDataContactsTiersGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTiersApiV1MasterDataContactsTiersGet>>
>;
export type ListTiersApiV1MasterDataContactsTiersGetQueryError = unknown;

export function useListTiersApiV1MasterDataContactsTiersGet<
  TData = Awaited<ReturnType<typeof listTiersApiV1MasterDataContactsTiersGet>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTiersApiV1MasterDataContactsTiersGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTiersApiV1MasterDataContactsTiersGet>>,
          TError,
          Awaited<ReturnType<typeof listTiersApiV1MasterDataContactsTiersGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListTiersApiV1MasterDataContactsTiersGet<
  TData = Awaited<ReturnType<typeof listTiersApiV1MasterDataContactsTiersGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTiersApiV1MasterDataContactsTiersGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTiersApiV1MasterDataContactsTiersGet>>,
          TError,
          Awaited<ReturnType<typeof listTiersApiV1MasterDataContactsTiersGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTiersApiV1MasterDataContactsTiersGet<
  TData = Awaited<ReturnType<typeof listTiersApiV1MasterDataContactsTiersGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTiersApiV1MasterDataContactsTiersGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Tiers
 */

export function useListTiersApiV1MasterDataContactsTiersGet<
  TData = Awaited<ReturnType<typeof listTiersApiV1MasterDataContactsTiersGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTiersApiV1MasterDataContactsTiersGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListTiersApiV1MasterDataContactsTiersGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new tier.
 * @summary Create Tier
 */
export const createTierApiV1MasterDataContactsTiersPost = (
  tierCreateRequest: TierCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/contacts/tiers`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: tierCreateRequest,
    signal
  });
};

export const getCreateTierApiV1MasterDataContactsTiersPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTierApiV1MasterDataContactsTiersPost>>,
    TError,
    { data: TierCreateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTierApiV1MasterDataContactsTiersPost>>,
  TError,
  { data: TierCreateRequest },
  TContext
> => {
  const mutationKey = ['createTierApiV1MasterDataContactsTiersPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTierApiV1MasterDataContactsTiersPost>>,
    { data: TierCreateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createTierApiV1MasterDataContactsTiersPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTierApiV1MasterDataContactsTiersPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createTierApiV1MasterDataContactsTiersPost>>
  >;
export type CreateTierApiV1MasterDataContactsTiersPostMutationBody =
  TierCreateRequest;
export type CreateTierApiV1MasterDataContactsTiersPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Tier
 */
export const useCreateTierApiV1MasterDataContactsTiersPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTierApiV1MasterDataContactsTiersPost>>,
      TError,
      { data: TierCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createTierApiV1MasterDataContactsTiersPost>>,
  TError,
  { data: TierCreateRequest },
  TContext
> => {
  const mutationOptions =
    getCreateTierApiV1MasterDataContactsTiersPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a tier by ID.
 * @summary Get Tier
 */
export const getTierApiV1MasterDataContactsTiersTierIdGet = (
  tierId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/contacts/tiers/${tierId}`,
    method: 'GET',
    signal
  });
};

export const getGetTierApiV1MasterDataContactsTiersTierIdGetQueryKey = (
  tierId?: string
) => {
  return [`/api/v1/master-data/contacts/tiers/${tierId}`] as const;
};

export const getGetTierApiV1MasterDataContactsTiersTierIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getTierApiV1MasterDataContactsTiersTierIdGet>
  >,
  TError = HTTPValidationError
>(
  tierId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTierApiV1MasterDataContactsTiersTierIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTierApiV1MasterDataContactsTiersTierIdGetQueryKey(tierId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTierApiV1MasterDataContactsTiersTierIdGet>>
  > = ({ signal }) =>
    getTierApiV1MasterDataContactsTiersTierIdGet(tierId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tierId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTierApiV1MasterDataContactsTiersTierIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTierApiV1MasterDataContactsTiersTierIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getTierApiV1MasterDataContactsTiersTierIdGet>>
  >;
export type GetTierApiV1MasterDataContactsTiersTierIdGetQueryError =
  HTTPValidationError;

export function useGetTierApiV1MasterDataContactsTiersTierIdGet<
  TData = Awaited<
    ReturnType<typeof getTierApiV1MasterDataContactsTiersTierIdGet>
  >,
  TError = HTTPValidationError
>(
  tierId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTierApiV1MasterDataContactsTiersTierIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTierApiV1MasterDataContactsTiersTierIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTierApiV1MasterDataContactsTiersTierIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTierApiV1MasterDataContactsTiersTierIdGet<
  TData = Awaited<
    ReturnType<typeof getTierApiV1MasterDataContactsTiersTierIdGet>
  >,
  TError = HTTPValidationError
>(
  tierId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTierApiV1MasterDataContactsTiersTierIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTierApiV1MasterDataContactsTiersTierIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTierApiV1MasterDataContactsTiersTierIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTierApiV1MasterDataContactsTiersTierIdGet<
  TData = Awaited<
    ReturnType<typeof getTierApiV1MasterDataContactsTiersTierIdGet>
  >,
  TError = HTTPValidationError
>(
  tierId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTierApiV1MasterDataContactsTiersTierIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Tier
 */

export function useGetTierApiV1MasterDataContactsTiersTierIdGet<
  TData = Awaited<
    ReturnType<typeof getTierApiV1MasterDataContactsTiersTierIdGet>
  >,
  TError = HTTPValidationError
>(
  tierId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTierApiV1MasterDataContactsTiersTierIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTierApiV1MasterDataContactsTiersTierIdGetQueryOptions(
      tierId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a tier.
 * @summary Update Tier
 */
export const updateTierApiV1MasterDataContactsTiersTierIdPut = (
  tierId: string,
  tierUpdateRequest: TierUpdateRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/contacts/tiers/${tierId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: tierUpdateRequest
  });
};

export const getUpdateTierApiV1MasterDataContactsTiersTierIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateTierApiV1MasterDataContactsTiersTierIdPut>
      >,
      TError,
      { tierId: string; data: TierUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof updateTierApiV1MasterDataContactsTiersTierIdPut>>,
    TError,
    { tierId: string; data: TierUpdateRequest },
    TContext
  > => {
    const mutationKey = ['updateTierApiV1MasterDataContactsTiersTierIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateTierApiV1MasterDataContactsTiersTierIdPut>
      >,
      { tierId: string; data: TierUpdateRequest }
    > = (props) => {
      const { tierId, data } = props ?? {};

      return updateTierApiV1MasterDataContactsTiersTierIdPut(tierId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTierApiV1MasterDataContactsTiersTierIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateTierApiV1MasterDataContactsTiersTierIdPut>>
  >;
export type UpdateTierApiV1MasterDataContactsTiersTierIdPutMutationBody =
  TierUpdateRequest;
export type UpdateTierApiV1MasterDataContactsTiersTierIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Tier
 */
export const useUpdateTierApiV1MasterDataContactsTiersTierIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateTierApiV1MasterDataContactsTiersTierIdPut>
      >,
      TError,
      { tierId: string; data: TierUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateTierApiV1MasterDataContactsTiersTierIdPut>>,
  TError,
  { tierId: string; data: TierUpdateRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateTierApiV1MasterDataContactsTiersTierIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a tier.
 * @summary Delete Tier
 */
export const deleteTierApiV1MasterDataContactsTiersTierIdDelete = (
  tierId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/contacts/tiers/${tierId}`,
    method: 'DELETE'
  });
};

export const getDeleteTierApiV1MasterDataContactsTiersTierIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteTierApiV1MasterDataContactsTiersTierIdDelete>
      >,
      TError,
      { tierId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteTierApiV1MasterDataContactsTiersTierIdDelete>
    >,
    TError,
    { tierId: string },
    TContext
  > => {
    const mutationKey = ['deleteTierApiV1MasterDataContactsTiersTierIdDelete'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteTierApiV1MasterDataContactsTiersTierIdDelete>
      >,
      { tierId: string }
    > = (props) => {
      const { tierId } = props ?? {};

      return deleteTierApiV1MasterDataContactsTiersTierIdDelete(tierId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteTierApiV1MasterDataContactsTiersTierIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteTierApiV1MasterDataContactsTiersTierIdDelete>
    >
  >;

export type DeleteTierApiV1MasterDataContactsTiersTierIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Tier
 */
export const useDeleteTierApiV1MasterDataContactsTiersTierIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteTierApiV1MasterDataContactsTiersTierIdDelete>
      >,
      TError,
      { tierId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteTierApiV1MasterDataContactsTiersTierIdDelete>
  >,
  TError,
  { tierId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteTierApiV1MasterDataContactsTiersTierIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Initialize default tiers for the tenant.
 * @summary Initialize Default Tiers
 */
export const initializeDefaultTiersApiV1MasterDataContactsTiersInitializeDefaultsPost =
  (signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/tiers/initialize-defaults`,
      method: 'POST',
      signal
    });
  };

export const getInitializeDefaultTiersApiV1MasterDataContactsTiersInitializeDefaultsPostMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof initializeDefaultTiersApiV1MasterDataContactsTiersInitializeDefaultsPost
        >
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof initializeDefaultTiersApiV1MasterDataContactsTiersInitializeDefaultsPost
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      'initializeDefaultTiersApiV1MasterDataContactsTiersInitializeDefaultsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof initializeDefaultTiersApiV1MasterDataContactsTiersInitializeDefaultsPost
        >
      >,
      void
    > = () => {
      return initializeDefaultTiersApiV1MasterDataContactsTiersInitializeDefaultsPost();
    };

    return { mutationFn, ...mutationOptions };
  };

export type InitializeDefaultTiersApiV1MasterDataContactsTiersInitializeDefaultsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof initializeDefaultTiersApiV1MasterDataContactsTiersInitializeDefaultsPost
      >
    >
  >;

export type InitializeDefaultTiersApiV1MasterDataContactsTiersInitializeDefaultsPostMutationError =
  unknown;

/**
 * @summary Initialize Default Tiers
 */
export const useInitializeDefaultTiersApiV1MasterDataContactsTiersInitializeDefaultsPost =
  <TError = unknown, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof initializeDefaultTiersApiV1MasterDataContactsTiersInitializeDefaultsPost
          >
        >,
        TError,
        void,
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof initializeDefaultTiersApiV1MasterDataContactsTiersInitializeDefaultsPost
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationOptions =
      getInitializeDefaultTiersApiV1MasterDataContactsTiersInitializeDefaultsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List companies in a tier.
 * @summary List Tier Organizations
 */
export const listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet =
  (
    tierId: string,
    params?: ListTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/tiers/${tierId}/organizations`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGetQueryKey =
  (
    tierId?: string,
    params?: ListTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGetParams
  ) => {
    return [
      `/api/v1/master-data/contacts/tiers/${tierId}/organizations`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet
      >
    >,
    TError = HTTPValidationError
  >(
    tierId: string,
    params?: ListTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGetQueryKey(
        tierId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet
        >
      >
    > = ({ signal }) =>
      listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet(
        tierId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!tierId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet
      >
    >
  >;
export type ListTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGetQueryError =
  HTTPValidationError;

export function useListTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet<
  TData = Awaited<
    ReturnType<
      typeof listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet
    >
  >,
  TError = HTTPValidationError
>(
  tierId: string,
  params:
    | undefined
    | ListTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet<
  TData = Awaited<
    ReturnType<
      typeof listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet
    >
  >,
  TError = HTTPValidationError
>(
  tierId: string,
  params?: ListTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet<
  TData = Awaited<
    ReturnType<
      typeof listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet
    >
  >,
  TError = HTTPValidationError
>(
  tierId: string,
  params?: ListTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Tier Organizations
 */

export function useListTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet<
  TData = Awaited<
    ReturnType<
      typeof listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet
    >
  >,
  TError = HTTPValidationError
>(
  tierId: string,
  params?: ListTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListTierOrganizationsApiV1MasterDataContactsTiersTierIdOrganizationsGetQueryOptions(
      tierId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Bulk assign companies to a tier.
 * @summary Assign Organizations To Tier
 */
export const assignOrganizationsToTierApiV1MasterDataContactsTiersTierIdOrganizationsPut =
  (
    tierId: string,
    bulkAssignOrganizationsRequest: BulkAssignOrganizationsRequest
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/tiers/${tierId}/organizations`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: bulkAssignOrganizationsRequest
    });
  };

export const getAssignOrganizationsToTierApiV1MasterDataContactsTiersTierIdOrganizationsPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof assignOrganizationsToTierApiV1MasterDataContactsTiersTierIdOrganizationsPut
        >
      >,
      TError,
      { tierId: string; data: BulkAssignOrganizationsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof assignOrganizationsToTierApiV1MasterDataContactsTiersTierIdOrganizationsPut
      >
    >,
    TError,
    { tierId: string; data: BulkAssignOrganizationsRequest },
    TContext
  > => {
    const mutationKey = [
      'assignOrganizationsToTierApiV1MasterDataContactsTiersTierIdOrganizationsPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof assignOrganizationsToTierApiV1MasterDataContactsTiersTierIdOrganizationsPut
        >
      >,
      { tierId: string; data: BulkAssignOrganizationsRequest }
    > = (props) => {
      const { tierId, data } = props ?? {};

      return assignOrganizationsToTierApiV1MasterDataContactsTiersTierIdOrganizationsPut(
        tierId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignOrganizationsToTierApiV1MasterDataContactsTiersTierIdOrganizationsPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof assignOrganizationsToTierApiV1MasterDataContactsTiersTierIdOrganizationsPut
      >
    >
  >;
export type AssignOrganizationsToTierApiV1MasterDataContactsTiersTierIdOrganizationsPutMutationBody =
  BulkAssignOrganizationsRequest;
export type AssignOrganizationsToTierApiV1MasterDataContactsTiersTierIdOrganizationsPutMutationError =
  HTTPValidationError;

/**
 * @summary Assign Organizations To Tier
 */
export const useAssignOrganizationsToTierApiV1MasterDataContactsTiersTierIdOrganizationsPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof assignOrganizationsToTierApiV1MasterDataContactsTiersTierIdOrganizationsPut
          >
        >,
        TError,
        { tierId: string; data: BulkAssignOrganizationsRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof assignOrganizationsToTierApiV1MasterDataContactsTiersTierIdOrganizationsPut
      >
    >,
    TError,
    { tierId: string; data: BulkAssignOrganizationsRequest },
    TContext
  > => {
    const mutationOptions =
      getAssignOrganizationsToTierApiV1MasterDataContactsTiersTierIdOrganizationsPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove a company from a tier.
 * @summary Remove Organization From Tier
 */
export const removeOrganizationFromTierApiV1MasterDataContactsTiersTierIdOrganizationsOrganizationIdDelete =
  (tierId: string, organizationId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/tiers/${tierId}/organizations/${organizationId}`,
      method: 'DELETE'
    });
  };

export const getRemoveOrganizationFromTierApiV1MasterDataContactsTiersTierIdOrganizationsOrganizationIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeOrganizationFromTierApiV1MasterDataContactsTiersTierIdOrganizationsOrganizationIdDelete
        >
      >,
      TError,
      { tierId: string; organizationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeOrganizationFromTierApiV1MasterDataContactsTiersTierIdOrganizationsOrganizationIdDelete
      >
    >,
    TError,
    { tierId: string; organizationId: string },
    TContext
  > => {
    const mutationKey = [
      'removeOrganizationFromTierApiV1MasterDataContactsTiersTierIdOrganizationsOrganizationIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeOrganizationFromTierApiV1MasterDataContactsTiersTierIdOrganizationsOrganizationIdDelete
        >
      >,
      { tierId: string; organizationId: string }
    > = (props) => {
      const { tierId, organizationId } = props ?? {};

      return removeOrganizationFromTierApiV1MasterDataContactsTiersTierIdOrganizationsOrganizationIdDelete(
        tierId,
        organizationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveOrganizationFromTierApiV1MasterDataContactsTiersTierIdOrganizationsOrganizationIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeOrganizationFromTierApiV1MasterDataContactsTiersTierIdOrganizationsOrganizationIdDelete
      >
    >
  >;

export type RemoveOrganizationFromTierApiV1MasterDataContactsTiersTierIdOrganizationsOrganizationIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Organization From Tier
 */
export const useRemoveOrganizationFromTierApiV1MasterDataContactsTiersTierIdOrganizationsOrganizationIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof removeOrganizationFromTierApiV1MasterDataContactsTiersTierIdOrganizationsOrganizationIdDelete
          >
        >,
        TError,
        { tierId: string; organizationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof removeOrganizationFromTierApiV1MasterDataContactsTiersTierIdOrganizationsOrganizationIdDelete
      >
    >,
    TError,
    { tierId: string; organizationId: string },
    TContext
  > => {
    const mutationOptions =
      getRemoveOrganizationFromTierApiV1MasterDataContactsTiersTierIdOrganizationsOrganizationIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Every cadence policy this tenant has configured.

Bounded reference data — at most one default row, one per tier, one per
ASSIGNABLE relationship type (8, fixed by config) and one per relationship
CLASS — so it is returned WHOLE and sliced client-side, Shape B in
`.claude/rules/rules-list-endpoints.md`. The class axis is the only one a tenant
can grow, and it is bounded by a vocabulary that tenant curates by hand in the
custom-fields admin: these are cohorts a human names ("Architects", "Interior
Designers"), not rows accumulated by events, so the set stays small for the same
reason the tier list does. An empty list is the honest answer for a tenant that
has configured nothing, and the settings page renders it as "not configured"
rather than as a chosen policy.
 * @summary List Cadence Policies
 */
export const listCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet = (
  signal?: AbortSignal
) => {
  return customInstance<CadencePolicyListResponse>({
    url: `/api/v1/master-data/contacts/cadence-policies`,
    method: 'GET',
    signal
  });
};

export const getListCadencePoliciesApiV1MasterDataContactsCadencePoliciesGetQueryKey =
  () => {
    return [`/api/v1/master-data/contacts/cadence-policies`] as const;
  };

export const getListCadencePoliciesApiV1MasterDataContactsCadencePoliciesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListCadencePoliciesApiV1MasterDataContactsCadencePoliciesGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet
        >
      >
    > = ({ signal }) =>
      listCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListCadencePoliciesApiV1MasterDataContactsCadencePoliciesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet
      >
    >
  >;
export type ListCadencePoliciesApiV1MasterDataContactsCadencePoliciesGetQueryError =
  unknown;

export function useListCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet<
  TData = Awaited<
    ReturnType<
      typeof listCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet<
  TData = Awaited<
    ReturnType<
      typeof listCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet<
  TData = Awaited<
    ReturnType<
      typeof listCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Cadence Policies
 */

export function useListCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet<
  TData = Awaited<
    ReturnType<
      typeof listCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCadencePoliciesApiV1MasterDataContactsCadencePoliciesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCadencePoliciesApiV1MasterDataContactsCadencePoliciesGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Set ONE scope's cadence (master_data contacts admin).

Upsert rather than create/update: a scope holds at most one policy and the
client names the scope, not a row id. ``cadence_days: null`` writes the
deliberate "this scope needs no cadence"; to inherit again, DELETE the row.
 * @summary Upsert Cadence Policy
 */
export const upsertCadencePolicyApiV1MasterDataContactsCadencePoliciesPut = (
  cadencePolicyUpsert: CadencePolicyUpsert
) => {
  return customInstance<CadencePolicyResponse>({
    url: `/api/v1/master-data/contacts/cadence-policies`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: cadencePolicyUpsert
  });
};

export const getUpsertCadencePolicyApiV1MasterDataContactsCadencePoliciesPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof upsertCadencePolicyApiV1MasterDataContactsCadencePoliciesPut
        >
      >,
      TError,
      { data: CadencePolicyUpsert },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof upsertCadencePolicyApiV1MasterDataContactsCadencePoliciesPut
      >
    >,
    TError,
    { data: CadencePolicyUpsert },
    TContext
  > => {
    const mutationKey = [
      'upsertCadencePolicyApiV1MasterDataContactsCadencePoliciesPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof upsertCadencePolicyApiV1MasterDataContactsCadencePoliciesPut
        >
      >,
      { data: CadencePolicyUpsert }
    > = (props) => {
      const { data } = props ?? {};

      return upsertCadencePolicyApiV1MasterDataContactsCadencePoliciesPut(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpsertCadencePolicyApiV1MasterDataContactsCadencePoliciesPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof upsertCadencePolicyApiV1MasterDataContactsCadencePoliciesPut
      >
    >
  >;
export type UpsertCadencePolicyApiV1MasterDataContactsCadencePoliciesPutMutationBody =
  CadencePolicyUpsert;
export type UpsertCadencePolicyApiV1MasterDataContactsCadencePoliciesPutMutationError =
  HTTPValidationError;

/**
 * @summary Upsert Cadence Policy
 */
export const useUpsertCadencePolicyApiV1MasterDataContactsCadencePoliciesPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof upsertCadencePolicyApiV1MasterDataContactsCadencePoliciesPut
        >
      >,
      TError,
      { data: CadencePolicyUpsert },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof upsertCadencePolicyApiV1MasterDataContactsCadencePoliciesPut
    >
  >,
  TError,
  { data: CadencePolicyUpsert },
  TContext
> => {
  const mutationOptions =
    getUpsertCadencePolicyApiV1MasterDataContactsCadencePoliciesPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Drop a policy row — i.e. make that scope inherit the next tier down.
 * @summary Delete Cadence Policy
 */
export const deleteCadencePolicyApiV1MasterDataContactsCadencePoliciesPolicyIdDelete =
  (policyId: string) => {
    return customInstance<CadencePolicyDeleteResult>({
      url: `/api/v1/master-data/contacts/cadence-policies/${policyId}`,
      method: 'DELETE'
    });
  };

export const getDeleteCadencePolicyApiV1MasterDataContactsCadencePoliciesPolicyIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteCadencePolicyApiV1MasterDataContactsCadencePoliciesPolicyIdDelete
        >
      >,
      TError,
      { policyId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteCadencePolicyApiV1MasterDataContactsCadencePoliciesPolicyIdDelete
      >
    >,
    TError,
    { policyId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteCadencePolicyApiV1MasterDataContactsCadencePoliciesPolicyIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteCadencePolicyApiV1MasterDataContactsCadencePoliciesPolicyIdDelete
        >
      >,
      { policyId: string }
    > = (props) => {
      const { policyId } = props ?? {};

      return deleteCadencePolicyApiV1MasterDataContactsCadencePoliciesPolicyIdDelete(
        policyId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteCadencePolicyApiV1MasterDataContactsCadencePoliciesPolicyIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteCadencePolicyApiV1MasterDataContactsCadencePoliciesPolicyIdDelete
      >
    >
  >;

export type DeleteCadencePolicyApiV1MasterDataContactsCadencePoliciesPolicyIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Cadence Policy
 */
export const useDeleteCadencePolicyApiV1MasterDataContactsCadencePoliciesPolicyIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteCadencePolicyApiV1MasterDataContactsCadencePoliciesPolicyIdDelete
          >
        >,
        TError,
        { policyId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteCadencePolicyApiV1MasterDataContactsCadencePoliciesPolicyIdDelete
      >
    >,
    TError,
    { policyId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteCadencePolicyApiV1MasterDataContactsCadencePoliciesPolicyIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The caller's OWN personal cadence rules.

Bounded reference data like its tenant sibling — at most one default row, one
per tier, one per assignable relationship type and one per relationship class,
all for ONE person — so it is returned WHOLE and sliced client-side, Shape B in
`.claude/rules/rules-list-endpoints.md`. An empty list means this person has set
nothing and inherits the tenant rungs, which is the honest answer rather than a
configured one.

A nullable `limit` MUST clamp through `resolve_limit`: FastAPI skips `le=`
validation when the value is None and SQLAlchemy drops the LIMIT clause
entirely, so "optional" would silently become an unbounded read. Nothing here
can grow past the tenant's tier and class counts, but the backstop costs one
line and the settings page still receives the whole set.
 * @summary List My Cadence Policies
 */
export const listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet =
  (
    params?: ListMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<UserCadencePolicyListResponse>({
      url: `/api/v1/master-data/contacts/my-cadence-policies`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGetQueryKey =
  (
    params?: ListMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGetParams
  ) => {
    return [
      `/api/v1/master-data/contacts/my-cadence-policies`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet
        >
      >
    > = ({ signal }) =>
      listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet
      >
    >
  >;
export type ListMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGetQueryError =
  HTTPValidationError;

export function useListMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet<
  TData = Awaited<
    ReturnType<
      typeof listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet<
  TData = Awaited<
    ReturnType<
      typeof listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet<
  TData = Awaited<
    ReturnType<
      typeof listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List My Cadence Policies
 */

export function useListMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet<
  TData = Awaited<
    ReturnType<
      typeof listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListMyCadencePoliciesApiV1MasterDataContactsMyCadencePoliciesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Set ONE scope's personal cadence rule for the caller.

The body is the tenant matrix's own ``CadencePolicyUpsert``: the scope
vocabulary is deliberately shared, so one settings control can edit either
ladder and neither can grow a scope the other has not heard of. What is NOT
shared is who the row belongs to, and that is not in the body — it is the
authenticated caller, so a client cannot name a user at all.

``cadence_days: null`` writes the deliberate "these need no cadence"; to inherit
the tenant rungs again, DELETE the row.
 * @summary Upsert My Cadence Policy
 */
export const upsertMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPut =
  (cadencePolicyUpsert: CadencePolicyUpsert) => {
    return customInstance<UserCadencePolicyResponse>({
      url: `/api/v1/master-data/contacts/my-cadence-policies`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: cadencePolicyUpsert
    });
  };

export const getUpsertMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof upsertMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPut
        >
      >,
      TError,
      { data: CadencePolicyUpsert },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof upsertMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPut
      >
    >,
    TError,
    { data: CadencePolicyUpsert },
    TContext
  > => {
    const mutationKey = [
      'upsertMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof upsertMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPut
        >
      >,
      { data: CadencePolicyUpsert }
    > = (props) => {
      const { data } = props ?? {};

      return upsertMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPut(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpsertMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof upsertMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPut
      >
    >
  >;
export type UpsertMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPutMutationBody =
  CadencePolicyUpsert;
export type UpsertMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPutMutationError =
  HTTPValidationError;

/**
 * @summary Upsert My Cadence Policy
 */
export const useUpsertMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof upsertMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPut
          >
        >,
        TError,
        { data: CadencePolicyUpsert },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof upsertMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPut
      >
    >,
    TError,
    { data: CadencePolicyUpsert },
    TContext
  > => {
    const mutationOptions =
      getUpsertMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Drop one of the caller's own rules — inherit the tenant rungs again.

The service bounds the lookup by ``user_id`` as well as by tenant, so a caller
handed somebody else's policy id gets the same 404 as one naming no row at all.
 * @summary Delete My Cadence Policy
 */
export const deleteMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPolicyIdDelete =
  (policyId: string) => {
    return customInstance<CadencePolicyDeleteResult>({
      url: `/api/v1/master-data/contacts/my-cadence-policies/${policyId}`,
      method: 'DELETE'
    });
  };

export const getDeleteMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPolicyIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPolicyIdDelete
        >
      >,
      TError,
      { policyId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPolicyIdDelete
      >
    >,
    TError,
    { policyId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPolicyIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPolicyIdDelete
        >
      >,
      { policyId: string }
    > = (props) => {
      const { policyId } = props ?? {};

      return deleteMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPolicyIdDelete(
        policyId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPolicyIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPolicyIdDelete
      >
    >
  >;

export type DeleteMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPolicyIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete My Cadence Policy
 */
export const useDeleteMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPolicyIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPolicyIdDelete
          >
        >,
        TError,
        { policyId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPolicyIdDelete
      >
    >,
    TError,
    { policyId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteMyCadencePolicyApiV1MasterDataContactsMyCadencePoliciesPolicyIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Resolve the cadence for up to :data:`_MAX_CADENCE_RESOLVE_IDS` records.

Batched by construction — the relationship-overview list decorates a whole page
with one call, and the detail page is the same call with one id. `subject_id` is
a REPEATABLE param (`?subject_id=a&subject_id=b`), never a comma-joined string.

Every requested id comes back, including one this tenant does not hold: it
resolves to `unset`, which is the same answer a caller would compute from an
absent entry and saves them branching on presence.

The ids are FAR-SIDE filtered first. A resolution is not just "the policy the
caller could have read off the settings page": `engaged_at` is the record's own
last-activity stamp and `cadence_due_at` / `is_lapsed` are derived from it, so
answering for an arbitrary id would disclose how recently a colleague has been
working a contact the caller may not see — the class in
`.claude/rules/rules-entity-link-far-side.md`, and this route is exposed to the
AI assistant. Filtered-out ids take the SAME `unset` answer as ids the tenant
does not hold, so the response never distinguishes "hidden from you" from "no
such record". No-op in `everyone` mode and for tenant admins.
 * @summary Resolve Cadence
 */
export const resolveCadenceApiV1MasterDataContactsCadenceResolveGet = (
  params: ResolveCadenceApiV1MasterDataContactsCadenceResolveGetParams,
  signal?: AbortSignal
) => {
  return customInstance<CadenceResolutionResponse>({
    url: `/api/v1/master-data/contacts/cadence/resolve`,
    method: 'GET',
    params,
    signal
  });
};

export const getResolveCadenceApiV1MasterDataContactsCadenceResolveGetQueryKey =
  (params?: ResolveCadenceApiV1MasterDataContactsCadenceResolveGetParams) => {
    return [
      `/api/v1/master-data/contacts/cadence/resolve`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getResolveCadenceApiV1MasterDataContactsCadenceResolveGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof resolveCadenceApiV1MasterDataContactsCadenceResolveGet>
    >,
    TError = HTTPValidationError
  >(
    params: ResolveCadenceApiV1MasterDataContactsCadenceResolveGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof resolveCadenceApiV1MasterDataContactsCadenceResolveGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getResolveCadenceApiV1MasterDataContactsCadenceResolveGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof resolveCadenceApiV1MasterDataContactsCadenceResolveGet
        >
      >
    > = ({ signal }) =>
      resolveCadenceApiV1MasterDataContactsCadenceResolveGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof resolveCadenceApiV1MasterDataContactsCadenceResolveGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ResolveCadenceApiV1MasterDataContactsCadenceResolveGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof resolveCadenceApiV1MasterDataContactsCadenceResolveGet>
    >
  >;
export type ResolveCadenceApiV1MasterDataContactsCadenceResolveGetQueryError =
  HTTPValidationError;

export function useResolveCadenceApiV1MasterDataContactsCadenceResolveGet<
  TData = Awaited<
    ReturnType<typeof resolveCadenceApiV1MasterDataContactsCadenceResolveGet>
  >,
  TError = HTTPValidationError
>(
  params: ResolveCadenceApiV1MasterDataContactsCadenceResolveGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof resolveCadenceApiV1MasterDataContactsCadenceResolveGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof resolveCadenceApiV1MasterDataContactsCadenceResolveGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof resolveCadenceApiV1MasterDataContactsCadenceResolveGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useResolveCadenceApiV1MasterDataContactsCadenceResolveGet<
  TData = Awaited<
    ReturnType<typeof resolveCadenceApiV1MasterDataContactsCadenceResolveGet>
  >,
  TError = HTTPValidationError
>(
  params: ResolveCadenceApiV1MasterDataContactsCadenceResolveGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof resolveCadenceApiV1MasterDataContactsCadenceResolveGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof resolveCadenceApiV1MasterDataContactsCadenceResolveGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof resolveCadenceApiV1MasterDataContactsCadenceResolveGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useResolveCadenceApiV1MasterDataContactsCadenceResolveGet<
  TData = Awaited<
    ReturnType<typeof resolveCadenceApiV1MasterDataContactsCadenceResolveGet>
  >,
  TError = HTTPValidationError
>(
  params: ResolveCadenceApiV1MasterDataContactsCadenceResolveGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof resolveCadenceApiV1MasterDataContactsCadenceResolveGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Resolve Cadence
 */

export function useResolveCadenceApiV1MasterDataContactsCadenceResolveGet<
  TData = Awaited<
    ReturnType<typeof resolveCadenceApiV1MasterDataContactsCadenceResolveGet>
  >,
  TError = HTTPValidationError
>(
  params: ResolveCadenceApiV1MasterDataContactsCadenceResolveGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof resolveCadenceApiV1MasterDataContactsCadenceResolveGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getResolveCadenceApiV1MasterDataContactsCadenceResolveGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Engagement decoration for ONE PAGE of the relationship-overview list.

A side channel rather than fields on `/people`, for two reasons. The columns
are opt-in, so a user who has not turned them on must not pay for four
cross-module reads on every keystroke of the search box; and the decorations
are the expensive half, so they follow the page rather than gating it.

`subject_id` is REPEATABLE (`?subject_id=a&subject_id=b`), never a comma-joined
string, and is capped at `MAX_ENGAGEMENT_SUBJECT_IDS` — the cap exists so a
hand-built request cannot turn one batched provider query into a scan of the
tenant.

Every requested id comes back. An id this caller may not see resolves to the
same unset-cadence, no-counts shape as one nothing is known about, so the
response never distinguishes "hidden from you" from "no such record".

Each signal is FAR-SIDE filtered by the module that owns it: the near-side
gate here says only that the caller may see these contacts, which is
structurally vacuous about their deals, orders and campaigns
(`.claude/rules/rules-entity-link-far-side.md`).
 * @summary Engagement Values
 */
export const engagementValuesApiV1MasterDataContactsEngagementValuesGet = (
  params: EngagementValuesApiV1MasterDataContactsEngagementValuesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<EngagementValuesResponse>({
    url: `/api/v1/master-data/contacts/engagement/values`,
    method: 'GET',
    params,
    signal
  });
};

export const getEngagementValuesApiV1MasterDataContactsEngagementValuesGetQueryKey =
  (
    params?: EngagementValuesApiV1MasterDataContactsEngagementValuesGetParams
  ) => {
    return [
      `/api/v1/master-data/contacts/engagement/values`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getEngagementValuesApiV1MasterDataContactsEngagementValuesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof engagementValuesApiV1MasterDataContactsEngagementValuesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: EngagementValuesApiV1MasterDataContactsEngagementValuesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof engagementValuesApiV1MasterDataContactsEngagementValuesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getEngagementValuesApiV1MasterDataContactsEngagementValuesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof engagementValuesApiV1MasterDataContactsEngagementValuesGet
        >
      >
    > = ({ signal }) =>
      engagementValuesApiV1MasterDataContactsEngagementValuesGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof engagementValuesApiV1MasterDataContactsEngagementValuesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type EngagementValuesApiV1MasterDataContactsEngagementValuesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof engagementValuesApiV1MasterDataContactsEngagementValuesGet
      >
    >
  >;
export type EngagementValuesApiV1MasterDataContactsEngagementValuesGetQueryError =
  HTTPValidationError;

export function useEngagementValuesApiV1MasterDataContactsEngagementValuesGet<
  TData = Awaited<
    ReturnType<
      typeof engagementValuesApiV1MasterDataContactsEngagementValuesGet
    >
  >,
  TError = HTTPValidationError
>(
  params: EngagementValuesApiV1MasterDataContactsEngagementValuesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof engagementValuesApiV1MasterDataContactsEngagementValuesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof engagementValuesApiV1MasterDataContactsEngagementValuesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof engagementValuesApiV1MasterDataContactsEngagementValuesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useEngagementValuesApiV1MasterDataContactsEngagementValuesGet<
  TData = Awaited<
    ReturnType<
      typeof engagementValuesApiV1MasterDataContactsEngagementValuesGet
    >
  >,
  TError = HTTPValidationError
>(
  params: EngagementValuesApiV1MasterDataContactsEngagementValuesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof engagementValuesApiV1MasterDataContactsEngagementValuesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof engagementValuesApiV1MasterDataContactsEngagementValuesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof engagementValuesApiV1MasterDataContactsEngagementValuesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useEngagementValuesApiV1MasterDataContactsEngagementValuesGet<
  TData = Awaited<
    ReturnType<
      typeof engagementValuesApiV1MasterDataContactsEngagementValuesGet
    >
  >,
  TError = HTTPValidationError
>(
  params: EngagementValuesApiV1MasterDataContactsEngagementValuesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof engagementValuesApiV1MasterDataContactsEngagementValuesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Engagement Values
 */

export function useEngagementValuesApiV1MasterDataContactsEngagementValuesGet<
  TData = Awaited<
    ReturnType<
      typeof engagementValuesApiV1MasterDataContactsEngagementValuesGet
    >
  >,
  TError = HTTPValidationError
>(
  params: EngagementValuesApiV1MasterDataContactsEngagementValuesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof engagementValuesApiV1MasterDataContactsEngagementValuesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getEngagementValuesApiV1MasterDataContactsEngagementValuesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The contacts summary strip, over the WHOLE filtered cohort.

It takes the LIST's filter params rather than a page of ids, and resolves them
through the same ``build_contact_list_filters`` +
``filtered_contact_ids_query`` pair the rows and the total come from. That is
the whole point: a strip folded from the loaded page would describe 25 records
while claiming to describe the segment, and a strip with a second filter
implementation would drift from the table beneath it the first time a filter
changed on one side only (``docs/design-system/ui-list-pages.md`` §11).

The caller's own viewable scope bounds the cohort, so two users filtering to
the same relationship legitimately see different numbers — the same numbers
their two tables show.
 * @summary Contact Engagement Summary
 */
export const contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet =
  (
    params?: ContactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<EngagementSummaryResponse>({
      url: `/api/v1/master-data/contacts/engagement/summary/people`,
      method: 'GET',
      params,
      signal
    });
  };

export const getContactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGetQueryKey =
  (
    params?: ContactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGetParams
  ) => {
    return [
      `/api/v1/master-data/contacts/engagement/summary/people`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getContactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ContactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getContactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet
        >
      >
    > = ({ signal }) =>
      contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ContactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet
      >
    >
  >;
export type ContactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGetQueryError =
  HTTPValidationError;

export function useContactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet<
  TData = Awaited<
    ReturnType<
      typeof contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ContactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useContactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet<
  TData = Awaited<
    ReturnType<
      typeof contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ContactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useContactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet<
  TData = Awaited<
    ReturnType<
      typeof contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ContactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Contact Engagement Summary
 */

export function useContactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet<
  TData = Awaited<
    ReturnType<
      typeof contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ContactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof contactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getContactEngagementSummaryApiV1MasterDataContactsEngagementSummaryPeopleGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The organizations summary strip. Same contract as its contacts twin above.

Two routes rather than one with a ``subject_type`` switch because the two
lists genuinely filter on different things (``industry``/``tier_id`` versus
``organization_id``/``country_code``), and folding them into one signature
would mean a query param that silently does nothing for half the callers.
 * @summary Organization Engagement Summary
 */
export const organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet =
  (
    params?: OrganizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<EngagementSummaryResponse>({
      url: `/api/v1/master-data/contacts/engagement/summary/organizations`,
      method: 'GET',
      params,
      signal
    });
  };

export const getOrganizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGetQueryKey =
  (
    params?: OrganizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGetParams
  ) => {
    return [
      `/api/v1/master-data/contacts/engagement/summary/organizations`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getOrganizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: OrganizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getOrganizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet
        >
      >
    > = ({ signal }) =>
      organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type OrganizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet
      >
    >
  >;
export type OrganizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGetQueryError =
  HTTPValidationError;

export function useOrganizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet<
  TData = Awaited<
    ReturnType<
      typeof organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | OrganizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useOrganizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet<
  TData = Awaited<
    ReturnType<
      typeof organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: OrganizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useOrganizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet<
  TData = Awaited<
    ReturnType<
      typeof organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: OrganizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Organization Engagement Summary
 */

export function useOrganizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet<
  TData = Awaited<
    ReturnType<
      typeof organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: OrganizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof organizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getOrganizationEngagementSummaryApiV1MasterDataContactsEngagementSummaryOrganizationsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List the tenant's relationship classes (active only unless include_inactive).
 * @summary List Relationship Classes
 */
export const listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet =
  (
    params?: ListRelationshipClassesApiV1MasterDataContactsRelationshipClassesGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/relationship-classes`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListRelationshipClassesApiV1MasterDataContactsRelationshipClassesGetQueryKey =
  (
    params?: ListRelationshipClassesApiV1MasterDataContactsRelationshipClassesGetParams
  ) => {
    return [
      `/api/v1/master-data/contacts/relationship-classes`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListRelationshipClassesApiV1MasterDataContactsRelationshipClassesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListRelationshipClassesApiV1MasterDataContactsRelationshipClassesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListRelationshipClassesApiV1MasterDataContactsRelationshipClassesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet
        >
      >
    > = ({ signal }) =>
      listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListRelationshipClassesApiV1MasterDataContactsRelationshipClassesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet
      >
    >
  >;
export type ListRelationshipClassesApiV1MasterDataContactsRelationshipClassesGetQueryError =
  HTTPValidationError;

export function useListRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet<
  TData = Awaited<
    ReturnType<
      typeof listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListRelationshipClassesApiV1MasterDataContactsRelationshipClassesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet<
  TData = Awaited<
    ReturnType<
      typeof listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListRelationshipClassesApiV1MasterDataContactsRelationshipClassesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet<
  TData = Awaited<
    ReturnType<
      typeof listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListRelationshipClassesApiV1MasterDataContactsRelationshipClassesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Relationship Classes
 */

export function useListRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet<
  TData = Awaited<
    ReturnType<
      typeof listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListRelationshipClassesApiV1MasterDataContactsRelationshipClassesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRelationshipClassesApiV1MasterDataContactsRelationshipClassesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListRelationshipClassesApiV1MasterDataContactsRelationshipClassesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a relationship class (master_data module admin).
 * @summary Create Relationship Class
 */
export const createRelationshipClassApiV1MasterDataContactsRelationshipClassesPost =
  (
    relationshipClassCreateRequest: RelationshipClassCreateRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/relationship-classes`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: relationshipClassCreateRequest,
      signal
    });
  };

export const getCreateRelationshipClassApiV1MasterDataContactsRelationshipClassesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createRelationshipClassApiV1MasterDataContactsRelationshipClassesPost
        >
      >,
      TError,
      { data: RelationshipClassCreateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createRelationshipClassApiV1MasterDataContactsRelationshipClassesPost
      >
    >,
    TError,
    { data: RelationshipClassCreateRequest },
    TContext
  > => {
    const mutationKey = [
      'createRelationshipClassApiV1MasterDataContactsRelationshipClassesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createRelationshipClassApiV1MasterDataContactsRelationshipClassesPost
        >
      >,
      { data: RelationshipClassCreateRequest }
    > = (props) => {
      const { data } = props ?? {};

      return createRelationshipClassApiV1MasterDataContactsRelationshipClassesPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateRelationshipClassApiV1MasterDataContactsRelationshipClassesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createRelationshipClassApiV1MasterDataContactsRelationshipClassesPost
      >
    >
  >;
export type CreateRelationshipClassApiV1MasterDataContactsRelationshipClassesPostMutationBody =
  RelationshipClassCreateRequest;
export type CreateRelationshipClassApiV1MasterDataContactsRelationshipClassesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Relationship Class
 */
export const useCreateRelationshipClassApiV1MasterDataContactsRelationshipClassesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createRelationshipClassApiV1MasterDataContactsRelationshipClassesPost
          >
        >,
        TError,
        { data: RelationshipClassCreateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createRelationshipClassApiV1MasterDataContactsRelationshipClassesPost
      >
    >,
    TError,
    { data: RelationshipClassCreateRequest },
    TContext
  > => {
    const mutationOptions =
      getCreateRelationshipClassApiV1MasterDataContactsRelationshipClassesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * How many organizations and contacts carry each class.

Declared ABOVE ``/{class_id}``: FastAPI matches in declaration order, and the
literal would otherwise be swallowed by the UUID path param.

A class is tenant-global while a custom-field definition belongs to exactly
one record type, so a field can be scoped to a class that no record of ITS
type carries — invisible everywhere, with no feedback at any point
(WI f130d85c). The definition dialog reads these counts to say so while the
admin is still choosing. Module-admin-gated like the class writes: it is
admin configuration diagnostics, and a bare record count would otherwise
sidestep the per-record visibility the list endpoints apply.
 * @summary Relationship Class Carrier Counts
 */
export const relationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet =
  (signal?: AbortSignal) => {
    return customInstance<RelationshipClassCarrierCountListResponse>({
      url: `/api/v1/master-data/contacts/relationship-classes/carrier-counts`,
      method: 'GET',
      signal
    });
  };

export const getRelationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGetQueryKey =
  () => {
    return [
      `/api/v1/master-data/contacts/relationship-classes/carrier-counts`
    ] as const;
  };

export const getRelationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof relationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof relationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getRelationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof relationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet
        >
      >
    > = ({ signal }) =>
      relationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet(
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof relationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type RelationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof relationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet
      >
    >
  >;
export type RelationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGetQueryError =
  unknown;

export function useRelationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet<
  TData = Awaited<
    ReturnType<
      typeof relationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof relationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof relationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof relationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useRelationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet<
  TData = Awaited<
    ReturnType<
      typeof relationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof relationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof relationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof relationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useRelationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet<
  TData = Awaited<
    ReturnType<
      typeof relationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof relationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Relationship Class Carrier Counts
 */

export function useRelationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet<
  TData = Awaited<
    ReturnType<
      typeof relationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof relationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getRelationshipClassCarrierCountsApiV1MasterDataContactsRelationshipClassesCarrierCountsGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a single relationship class.
 * @summary Get Relationship Class
 */
export const getRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet =
  (classId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/relationship-classes/${classId}`,
      method: 'GET',
      signal
    });
  };

export const getGetRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGetQueryKey =
  (classId?: string) => {
    return [
      `/api/v1/master-data/contacts/relationship-classes/${classId}`
    ] as const;
  };

export const getGetRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    classId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGetQueryKey(
        classId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet
        >
      >
    > = ({ signal }) =>
      getRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet(
        classId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!classId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet
      >
    >
  >;
export type GetRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGetQueryError =
  HTTPValidationError;

export function useGetRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet<
  TData = Awaited<
    ReturnType<
      typeof getRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet
    >
  >,
  TError = HTTPValidationError
>(
  classId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet<
  TData = Awaited<
    ReturnType<
      typeof getRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet
    >
  >,
  TError = HTTPValidationError
>(
  classId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet<
  TData = Awaited<
    ReturnType<
      typeof getRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet
    >
  >,
  TError = HTTPValidationError
>(
  classId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Relationship Class
 */

export function useGetRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet<
  TData = Awaited<
    ReturnType<
      typeof getRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet
    >
  >,
  TError = HTTPValidationError
>(
  classId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdGetQueryOptions(
      classId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a relationship class (master_data module admin). The key is immutable.
 * @summary Update Relationship Class
 */
export const updateRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdPut =
  (
    classId: string,
    relationshipClassUpdateRequest: RelationshipClassUpdateRequest
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/relationship-classes/${classId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: relationshipClassUpdateRequest
    });
  };

export const getUpdateRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdPut
        >
      >,
      TError,
      { classId: string; data: RelationshipClassUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdPut
      >
    >,
    TError,
    { classId: string; data: RelationshipClassUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updateRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdPut
        >
      >,
      { classId: string; data: RelationshipClassUpdateRequest }
    > = (props) => {
      const { classId, data } = props ?? {};

      return updateRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdPut(
        classId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdPut
      >
    >
  >;
export type UpdateRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdPutMutationBody =
  RelationshipClassUpdateRequest;
export type UpdateRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Relationship Class
 */
export const useUpdateRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdPut
          >
        >,
        TError,
        { classId: string; data: RelationshipClassUpdateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdPut
      >
    >,
    TError,
    { classId: string; data: RelationshipClassUpdateRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Hard-delete a class (master_data module admin). Cascades remove memberships.
 * @summary Delete Relationship Class
 */
export const deleteRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdDelete =
  (classId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/relationship-classes/${classId}`,
      method: 'DELETE'
    });
  };

export const getDeleteRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdDelete
        >
      >,
      TError,
      { classId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdDelete
      >
    >,
    TError,
    { classId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdDelete
        >
      >,
      { classId: string }
    > = (props) => {
      const { classId } = props ?? {};

      return deleteRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdDelete(
        classId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdDelete
      >
    >
  >;

export type DeleteRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Relationship Class
 */
export const useDeleteRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdDelete
          >
        >,
        TError,
        { classId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdDelete
      >
    >,
    TError,
    { classId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteRelationshipClassApiV1MasterDataContactsRelationshipClassesClassIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List contacts with filtering and pagination.
 * @summary List Contacts
 */
export const listContactsApiV1MasterDataContactsPeopleGet = (
  params?: ListContactsApiV1MasterDataContactsPeopleGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/contacts/people`,
    method: 'GET',
    params,
    signal
  });
};

export const getListContactsApiV1MasterDataContactsPeopleGetQueryKey = (
  params?: ListContactsApiV1MasterDataContactsPeopleGetParams
) => {
  return [
    `/api/v1/master-data/contacts/people`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListContactsApiV1MasterDataContactsPeopleGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listContactsApiV1MasterDataContactsPeopleGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListContactsApiV1MasterDataContactsPeopleGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listContactsApiV1MasterDataContactsPeopleGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListContactsApiV1MasterDataContactsPeopleGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listContactsApiV1MasterDataContactsPeopleGet>>
  > = ({ signal }) =>
    listContactsApiV1MasterDataContactsPeopleGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listContactsApiV1MasterDataContactsPeopleGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListContactsApiV1MasterDataContactsPeopleGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listContactsApiV1MasterDataContactsPeopleGet>>
  >;
export type ListContactsApiV1MasterDataContactsPeopleGetQueryError =
  HTTPValidationError;

export function useListContactsApiV1MasterDataContactsPeopleGet<
  TData = Awaited<
    ReturnType<typeof listContactsApiV1MasterDataContactsPeopleGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListContactsApiV1MasterDataContactsPeopleGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listContactsApiV1MasterDataContactsPeopleGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listContactsApiV1MasterDataContactsPeopleGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listContactsApiV1MasterDataContactsPeopleGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListContactsApiV1MasterDataContactsPeopleGet<
  TData = Awaited<
    ReturnType<typeof listContactsApiV1MasterDataContactsPeopleGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListContactsApiV1MasterDataContactsPeopleGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listContactsApiV1MasterDataContactsPeopleGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listContactsApiV1MasterDataContactsPeopleGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listContactsApiV1MasterDataContactsPeopleGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListContactsApiV1MasterDataContactsPeopleGet<
  TData = Awaited<
    ReturnType<typeof listContactsApiV1MasterDataContactsPeopleGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListContactsApiV1MasterDataContactsPeopleGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listContactsApiV1MasterDataContactsPeopleGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Contacts
 */

export function useListContactsApiV1MasterDataContactsPeopleGet<
  TData = Awaited<
    ReturnType<typeof listContactsApiV1MasterDataContactsPeopleGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListContactsApiV1MasterDataContactsPeopleGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listContactsApiV1MasterDataContactsPeopleGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListContactsApiV1MasterDataContactsPeopleGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new contact.
 * @summary Create Contact
 */
export const createContactApiV1MasterDataContactsPeoplePost = (
  contactCreateRequest: ContactCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/contacts/people`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: contactCreateRequest,
    signal
  });
};

export const getCreateContactApiV1MasterDataContactsPeoplePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createContactApiV1MasterDataContactsPeoplePost>
      >,
      TError,
      { data: ContactCreateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof createContactApiV1MasterDataContactsPeoplePost>>,
    TError,
    { data: ContactCreateRequest },
    TContext
  > => {
    const mutationKey = ['createContactApiV1MasterDataContactsPeoplePost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createContactApiV1MasterDataContactsPeoplePost>
      >,
      { data: ContactCreateRequest }
    > = (props) => {
      const { data } = props ?? {};

      return createContactApiV1MasterDataContactsPeoplePost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateContactApiV1MasterDataContactsPeoplePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createContactApiV1MasterDataContactsPeoplePost>>
  >;
export type CreateContactApiV1MasterDataContactsPeoplePostMutationBody =
  ContactCreateRequest;
export type CreateContactApiV1MasterDataContactsPeoplePostMutationError =
  HTTPValidationError;

/**
 * @summary Create Contact
 */
export const useCreateContactApiV1MasterDataContactsPeoplePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createContactApiV1MasterDataContactsPeoplePost>
      >,
      TError,
      { data: ContactCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createContactApiV1MasterDataContactsPeoplePost>>,
  TError,
  { data: ContactCreateRequest },
  TContext
> => {
  const mutationOptions =
    getCreateContactApiV1MasterDataContactsPeoplePostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a contact by ID.
 * @summary Get Contact
 */
export const getContactApiV1MasterDataContactsPeopleContactIdGet = (
  contactId: string,
  params?: GetContactApiV1MasterDataContactsPeopleContactIdGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/contacts/people/${contactId}`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetContactApiV1MasterDataContactsPeopleContactIdGetQueryKey = (
  contactId?: string,
  params?: GetContactApiV1MasterDataContactsPeopleContactIdGetParams
) => {
  return [
    `/api/v1/master-data/contacts/people/${contactId}`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetContactApiV1MasterDataContactsPeopleContactIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getContactApiV1MasterDataContactsPeopleContactIdGet>
    >,
    TError = HTTPValidationError
  >(
    contactId: string,
    params?: GetContactApiV1MasterDataContactsPeopleContactIdGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getContactApiV1MasterDataContactsPeopleContactIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetContactApiV1MasterDataContactsPeopleContactIdGetQueryKey(
        contactId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getContactApiV1MasterDataContactsPeopleContactIdGet>
      >
    > = ({ signal }) =>
      getContactApiV1MasterDataContactsPeopleContactIdGet(
        contactId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!contactId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getContactApiV1MasterDataContactsPeopleContactIdGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetContactApiV1MasterDataContactsPeopleContactIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getContactApiV1MasterDataContactsPeopleContactIdGet>
    >
  >;
export type GetContactApiV1MasterDataContactsPeopleContactIdGetQueryError =
  HTTPValidationError;

export function useGetContactApiV1MasterDataContactsPeopleContactIdGet<
  TData = Awaited<
    ReturnType<typeof getContactApiV1MasterDataContactsPeopleContactIdGet>
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params: undefined | GetContactApiV1MasterDataContactsPeopleContactIdGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getContactApiV1MasterDataContactsPeopleContactIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getContactApiV1MasterDataContactsPeopleContactIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getContactApiV1MasterDataContactsPeopleContactIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetContactApiV1MasterDataContactsPeopleContactIdGet<
  TData = Awaited<
    ReturnType<typeof getContactApiV1MasterDataContactsPeopleContactIdGet>
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params?: GetContactApiV1MasterDataContactsPeopleContactIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getContactApiV1MasterDataContactsPeopleContactIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getContactApiV1MasterDataContactsPeopleContactIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getContactApiV1MasterDataContactsPeopleContactIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetContactApiV1MasterDataContactsPeopleContactIdGet<
  TData = Awaited<
    ReturnType<typeof getContactApiV1MasterDataContactsPeopleContactIdGet>
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params?: GetContactApiV1MasterDataContactsPeopleContactIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getContactApiV1MasterDataContactsPeopleContactIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Contact
 */

export function useGetContactApiV1MasterDataContactsPeopleContactIdGet<
  TData = Awaited<
    ReturnType<typeof getContactApiV1MasterDataContactsPeopleContactIdGet>
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params?: GetContactApiV1MasterDataContactsPeopleContactIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getContactApiV1MasterDataContactsPeopleContactIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetContactApiV1MasterDataContactsPeopleContactIdGetQueryOptions(
      contactId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a contact.
 * @summary Update Contact
 */
export const updateContactApiV1MasterDataContactsPeopleContactIdPut = (
  contactId: string,
  contactUpdateRequest: ContactUpdateRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/contacts/people/${contactId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: contactUpdateRequest
  });
};

export const getUpdateContactApiV1MasterDataContactsPeopleContactIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateContactApiV1MasterDataContactsPeopleContactIdPut
        >
      >,
      TError,
      { contactId: string; data: ContactUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateContactApiV1MasterDataContactsPeopleContactIdPut>
    >,
    TError,
    { contactId: string; data: ContactUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updateContactApiV1MasterDataContactsPeopleContactIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateContactApiV1MasterDataContactsPeopleContactIdPut
        >
      >,
      { contactId: string; data: ContactUpdateRequest }
    > = (props) => {
      const { contactId, data } = props ?? {};

      return updateContactApiV1MasterDataContactsPeopleContactIdPut(
        contactId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateContactApiV1MasterDataContactsPeopleContactIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateContactApiV1MasterDataContactsPeopleContactIdPut>
    >
  >;
export type UpdateContactApiV1MasterDataContactsPeopleContactIdPutMutationBody =
  ContactUpdateRequest;
export type UpdateContactApiV1MasterDataContactsPeopleContactIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Contact
 */
export const useUpdateContactApiV1MasterDataContactsPeopleContactIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateContactApiV1MasterDataContactsPeopleContactIdPut
        >
      >,
      TError,
      { contactId: string; data: ContactUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateContactApiV1MasterDataContactsPeopleContactIdPut>
  >,
  TError,
  { contactId: string; data: ContactUpdateRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateContactApiV1MasterDataContactsPeopleContactIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a contact (soft delete), refused while a live record depends on it.
 * @summary Delete Contact
 */
export const deleteContactApiV1MasterDataContactsPeopleContactIdDelete = (
  contactId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/contacts/people/${contactId}`,
    method: 'DELETE'
  });
};

export const getDeleteContactApiV1MasterDataContactsPeopleContactIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteContactApiV1MasterDataContactsPeopleContactIdDelete
        >
      >,
      TError,
      { contactId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteContactApiV1MasterDataContactsPeopleContactIdDelete
      >
    >,
    TError,
    { contactId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteContactApiV1MasterDataContactsPeopleContactIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteContactApiV1MasterDataContactsPeopleContactIdDelete
        >
      >,
      { contactId: string }
    > = (props) => {
      const { contactId } = props ?? {};

      return deleteContactApiV1MasterDataContactsPeopleContactIdDelete(
        contactId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteContactApiV1MasterDataContactsPeopleContactIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteContactApiV1MasterDataContactsPeopleContactIdDelete
      >
    >
  >;

export type DeleteContactApiV1MasterDataContactsPeopleContactIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Contact
 */
export const useDeleteContactApiV1MasterDataContactsPeopleContactIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteContactApiV1MasterDataContactsPeopleContactIdDelete
        >
      >,
      TError,
      { contactId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteContactApiV1MasterDataContactsPeopleContactIdDelete>
  >,
  TError,
  { contactId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteContactApiV1MasterDataContactsPeopleContactIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Assert one relationship on a contact. Idempotent.

An INCREMENTAL pair, deliberately, rather than a field on the update payload:
this column is written one element at a time by several owners (the deal
lifecycle, lead capture, the bank tagger), so a whole-array PUT is a silent
lost update — the client transmits what it read on page load and discards
every element added since (`.claude/rules/rules-entity-link-far-side.md`
§ "A link written ONE ELEMENT AT A TIME").

**Adding is never refused.** The user knows things the system does not: a
customer of the platform, a prospect nobody has opened a deal for yet. Only
RETRACTING somebody else's evidence is guarded — see the DELETE twin.

**``lead`` also opens the Pipeline funnel**, because the rung and
``pipeline_contact_status`` are two halves of one fact
(`.claude/rules/rules-pipeline.md`). ``add_relationship_tag`` is the generic
one-element write serving all three rungs, so it cannot open a funnel of its
own and this caller owes the seam call — without it the promoted contact
reaches the Leads list with a blank status, absent from the Kanban and from
every status count.
 * @summary Add Contact Relationship
 */
export const addContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValuePost =
  (contactId: string, value: string, signal?: AbortSignal) => {
    return customInstance<RelationshipMutationResponse>({
      url: `/api/v1/master-data/contacts/people/${contactId}/relationship/${value}`,
      method: 'POST',
      signal
    });
  };

export const getAddContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValuePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValuePost
        >
      >,
      TError,
      { contactId: string; value: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValuePost
      >
    >,
    TError,
    { contactId: string; value: string },
    TContext
  > => {
    const mutationKey = [
      'addContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValuePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValuePost
        >
      >,
      { contactId: string; value: string }
    > = (props) => {
      const { contactId, value } = props ?? {};

      return addContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValuePost(
        contactId,
        value
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValuePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValuePost
      >
    >
  >;

export type AddContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValuePostMutationError =
  HTTPValidationError;

/**
 * @summary Add Contact Relationship
 */
export const useAddContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValuePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValuePost
          >
        >,
        TError,
        { contactId: string; value: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValuePost
      >
    >,
    TError,
    { contactId: string; value: string },
    TContext
  > => {
    const mutationOptions =
      getAddContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValuePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Retract one relationship a user asserted. Idempotent.

Refused with ``RELATIONSHIP_PINNED`` (409) while a live record still evidences
the value — a confirmed sales order naming this contact as its customer, an
open deal making them a prospect. The refusal names that record so the reader
knows what to go and change; the remedy is to retract the RECORD, never to
overrule the invariant. Contract:
``shared/services/relationship_pin_registry.py``.
 * @summary Remove Contact Relationship
 */
export const removeContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValueDelete =
  (contactId: string, value: string) => {
    return customInstance<RelationshipMutationResponse>({
      url: `/api/v1/master-data/contacts/people/${contactId}/relationship/${value}`,
      method: 'DELETE'
    });
  };

export const getRemoveContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValueDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValueDelete
        >
      >,
      TError,
      { contactId: string; value: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValueDelete
      >
    >,
    TError,
    { contactId: string; value: string },
    TContext
  > => {
    const mutationKey = [
      'removeContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValueDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValueDelete
        >
      >,
      { contactId: string; value: string }
    > = (props) => {
      const { contactId, value } = props ?? {};

      return removeContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValueDelete(
        contactId,
        value
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValueDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValueDelete
      >
    >
  >;

export type RemoveContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValueDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Contact Relationship
 */
export const useRemoveContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValueDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof removeContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValueDelete
          >
        >,
        TError,
        { contactId: string; value: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof removeContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValueDelete
      >
    >,
    TError,
    { contactId: string; value: string },
    TContext
  > => {
    const mutationOptions =
      getRemoveContactRelationshipApiV1MasterDataContactsPeopleContactIdRelationshipValueDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Assert one relationship on an organization. Idempotent.

The company twin of :func:`add_contact_relationship` — same contract, same
reasons; see that docstring.
 * @summary Add Organization Relationship
 */
export const addOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValuePost =
  (organizationId: string, value: string, signal?: AbortSignal) => {
    return customInstance<RelationshipMutationResponse>({
      url: `/api/v1/master-data/contacts/organizations/${organizationId}/relationship/${value}`,
      method: 'POST',
      signal
    });
  };

export const getAddOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValuePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValuePost
        >
      >,
      TError,
      { organizationId: string; value: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValuePost
      >
    >,
    TError,
    { organizationId: string; value: string },
    TContext
  > => {
    const mutationKey = [
      'addOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValuePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValuePost
        >
      >,
      { organizationId: string; value: string }
    > = (props) => {
      const { organizationId, value } = props ?? {};

      return addOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValuePost(
        organizationId,
        value
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValuePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValuePost
      >
    >
  >;

export type AddOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValuePostMutationError =
  HTTPValidationError;

/**
 * @summary Add Organization Relationship
 */
export const useAddOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValuePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValuePost
          >
        >,
        TError,
        { organizationId: string; value: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValuePost
      >
    >,
    TError,
    { organizationId: string; value: string },
    TContext
  > => {
    const mutationOptions =
      getAddOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValuePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Retract one relationship a user asserted on an organization. Idempotent.

The company twin of :func:`remove_contact_relationship` — same pin guard, same
409, same remedy; see that docstring.
 * @summary Remove Organization Relationship
 */
export const removeOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValueDelete =
  (organizationId: string, value: string) => {
    return customInstance<RelationshipMutationResponse>({
      url: `/api/v1/master-data/contacts/organizations/${organizationId}/relationship/${value}`,
      method: 'DELETE'
    });
  };

export const getRemoveOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValueDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValueDelete
        >
      >,
      TError,
      { organizationId: string; value: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValueDelete
      >
    >,
    TError,
    { organizationId: string; value: string },
    TContext
  > => {
    const mutationKey = [
      'removeOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValueDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValueDelete
        >
      >,
      { organizationId: string; value: string }
    > = (props) => {
      const { organizationId, value } = props ?? {};

      return removeOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValueDelete(
        organizationId,
        value
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValueDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValueDelete
      >
    >
  >;

export type RemoveOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValueDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Organization Relationship
 */
export const useRemoveOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValueDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof removeOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValueDelete
          >
        >,
        TError,
        { organizationId: string; value: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof removeOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValueDelete
      >
    >,
    TError,
    { organizationId: string; value: string },
    TContext
  > => {
    const mutationOptions =
      getRemoveOrganizationRelationshipApiV1MasterDataContactsOrganizationsOrganizationIdRelationshipValueDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Archive a contact.
 * @summary Archive Contact
 */
export const archiveContactApiV1MasterDataContactsPeopleContactIdArchivePost = (
  contactId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/contacts/people/${contactId}/archive`,
    method: 'POST',
    signal
  });
};

export const getArchiveContactApiV1MasterDataContactsPeopleContactIdArchivePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof archiveContactApiV1MasterDataContactsPeopleContactIdArchivePost
        >
      >,
      TError,
      { contactId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof archiveContactApiV1MasterDataContactsPeopleContactIdArchivePost
      >
    >,
    TError,
    { contactId: string },
    TContext
  > => {
    const mutationKey = [
      'archiveContactApiV1MasterDataContactsPeopleContactIdArchivePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof archiveContactApiV1MasterDataContactsPeopleContactIdArchivePost
        >
      >,
      { contactId: string }
    > = (props) => {
      const { contactId } = props ?? {};

      return archiveContactApiV1MasterDataContactsPeopleContactIdArchivePost(
        contactId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ArchiveContactApiV1MasterDataContactsPeopleContactIdArchivePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof archiveContactApiV1MasterDataContactsPeopleContactIdArchivePost
      >
    >
  >;

export type ArchiveContactApiV1MasterDataContactsPeopleContactIdArchivePostMutationError =
  HTTPValidationError;

/**
 * @summary Archive Contact
 */
export const useArchiveContactApiV1MasterDataContactsPeopleContactIdArchivePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof archiveContactApiV1MasterDataContactsPeopleContactIdArchivePost
          >
        >,
        TError,
        { contactId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof archiveContactApiV1MasterDataContactsPeopleContactIdArchivePost
      >
    >,
    TError,
    { contactId: string },
    TContext
  > => {
    const mutationOptions =
      getArchiveContactApiV1MasterDataContactsPeopleContactIdArchivePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Unarchive a contact.
 * @summary Unarchive Contact
 */
export const unarchiveContactApiV1MasterDataContactsPeopleContactIdUnarchivePost =
  (contactId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/people/${contactId}/unarchive`,
      method: 'POST',
      signal
    });
  };

export const getUnarchiveContactApiV1MasterDataContactsPeopleContactIdUnarchivePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unarchiveContactApiV1MasterDataContactsPeopleContactIdUnarchivePost
        >
      >,
      TError,
      { contactId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof unarchiveContactApiV1MasterDataContactsPeopleContactIdUnarchivePost
      >
    >,
    TError,
    { contactId: string },
    TContext
  > => {
    const mutationKey = [
      'unarchiveContactApiV1MasterDataContactsPeopleContactIdUnarchivePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof unarchiveContactApiV1MasterDataContactsPeopleContactIdUnarchivePost
        >
      >,
      { contactId: string }
    > = (props) => {
      const { contactId } = props ?? {};

      return unarchiveContactApiV1MasterDataContactsPeopleContactIdUnarchivePost(
        contactId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnarchiveContactApiV1MasterDataContactsPeopleContactIdUnarchivePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof unarchiveContactApiV1MasterDataContactsPeopleContactIdUnarchivePost
      >
    >
  >;

export type UnarchiveContactApiV1MasterDataContactsPeopleContactIdUnarchivePostMutationError =
  HTTPValidationError;

/**
 * @summary Unarchive Contact
 */
export const useUnarchiveContactApiV1MasterDataContactsPeopleContactIdUnarchivePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof unarchiveContactApiV1MasterDataContactsPeopleContactIdUnarchivePost
          >
        >,
        TError,
        { contactId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof unarchiveContactApiV1MasterDataContactsPeopleContactIdUnarchivePost
      >
    >,
    TError,
    { contactId: string },
    TContext
  > => {
    const mutationOptions =
      getUnarchiveContactApiV1MasterDataContactsPeopleContactIdUnarchivePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Deletion-impact preview for a contact (deletion-and-cascade-design §5.1).

VIEWER floor, mirroring the organization twin above — see its docstring for
why the counts a viewer sees here are not a far-side leak.
 * @summary Get Contact Deletion Impact
 */
export const getContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet =
  (contactId: string, signal?: AbortSignal) => {
    return customInstance<DeletionImpact>({
      url: `/api/v1/master-data/contacts/people/${contactId}/deletion-impact`,
      method: 'GET',
      signal
    });
  };

export const getGetContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGetQueryKey =
  (contactId?: string) => {
    return [
      `/api/v1/master-data/contacts/people/${contactId}/deletion-impact`
    ] as const;
  };

export const getGetContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet
      >
    >,
    TError = HTTPValidationError
  >(
    contactId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGetQueryKey(
        contactId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet
        >
      >
    > = ({ signal }) =>
      getContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet(
        contactId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!contactId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet
      >
    >
  >;
export type GetContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGetQueryError =
  HTTPValidationError;

export function useGetContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet<
  TData = Awaited<
    ReturnType<
      typeof getContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet<
  TData = Awaited<
    ReturnType<
      typeof getContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet<
  TData = Awaited<
    ReturnType<
      typeof getContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Contact Deletion Impact
 */

export function useGetContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet<
  TData = Awaited<
    ReturnType<
      typeof getContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetContactDeletionImpactApiV1MasterDataContactsPeopleContactIdDeletionImpactGetQueryOptions(
      contactId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Bulk delete contacts — the loaded ids, or every row matching the filters.

Soft delete (``deleted_at``), one set-based UPDATE, one batched audit write.
Scope resolution — and the EDITOR floor on both paths — is
:func:`_resolve_bulk_contact_ids`.

**Partial, not all-or-nothing.** Contacts a live record still depends on are
KEPT and named; the rest are deleted. Refusing the whole call over one blocked
row would make the user hunt for it and re-select, which is most of the
friction the guard exists to remove.
 * @summary Bulk Delete Contacts
 */
export const bulkDeleteContactsApiV1MasterDataContactsPeopleBulkDeletePost = (
  bulkContactRequest: BulkContactRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/contacts/people/bulk-delete`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkContactRequest,
    signal
  });
};

export const getBulkDeleteContactsApiV1MasterDataContactsPeopleBulkDeletePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkDeleteContactsApiV1MasterDataContactsPeopleBulkDeletePost
        >
      >,
      TError,
      { data: BulkContactRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkDeleteContactsApiV1MasterDataContactsPeopleBulkDeletePost
      >
    >,
    TError,
    { data: BulkContactRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkDeleteContactsApiV1MasterDataContactsPeopleBulkDeletePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkDeleteContactsApiV1MasterDataContactsPeopleBulkDeletePost
        >
      >,
      { data: BulkContactRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkDeleteContactsApiV1MasterDataContactsPeopleBulkDeletePost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkDeleteContactsApiV1MasterDataContactsPeopleBulkDeletePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkDeleteContactsApiV1MasterDataContactsPeopleBulkDeletePost
      >
    >
  >;
export type BulkDeleteContactsApiV1MasterDataContactsPeopleBulkDeletePostMutationBody =
  BulkContactRequest;
export type BulkDeleteContactsApiV1MasterDataContactsPeopleBulkDeletePostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Delete Contacts
 */
export const useBulkDeleteContactsApiV1MasterDataContactsPeopleBulkDeletePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof bulkDeleteContactsApiV1MasterDataContactsPeopleBulkDeletePost
          >
        >,
        TError,
        { data: BulkContactRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof bulkDeleteContactsApiV1MasterDataContactsPeopleBulkDeletePost
      >
    >,
    TError,
    { data: BulkContactRequest },
    TContext
  > => {
    const mutationOptions =
      getBulkDeleteContactsApiV1MasterDataContactsPeopleBulkDeletePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Bulk archive contacts — the loaded ids, or every row matching the filters.
 * @summary Bulk Archive Contacts
 */
export const bulkArchiveContactsApiV1MasterDataContactsPeopleBulkArchivePost = (
  bulkContactRequest: BulkContactRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/contacts/people/bulk-archive`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkContactRequest,
    signal
  });
};

export const getBulkArchiveContactsApiV1MasterDataContactsPeopleBulkArchivePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkArchiveContactsApiV1MasterDataContactsPeopleBulkArchivePost
        >
      >,
      TError,
      { data: BulkContactRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkArchiveContactsApiV1MasterDataContactsPeopleBulkArchivePost
      >
    >,
    TError,
    { data: BulkContactRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkArchiveContactsApiV1MasterDataContactsPeopleBulkArchivePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkArchiveContactsApiV1MasterDataContactsPeopleBulkArchivePost
        >
      >,
      { data: BulkContactRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkArchiveContactsApiV1MasterDataContactsPeopleBulkArchivePost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkArchiveContactsApiV1MasterDataContactsPeopleBulkArchivePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkArchiveContactsApiV1MasterDataContactsPeopleBulkArchivePost
      >
    >
  >;
export type BulkArchiveContactsApiV1MasterDataContactsPeopleBulkArchivePostMutationBody =
  BulkContactRequest;
export type BulkArchiveContactsApiV1MasterDataContactsPeopleBulkArchivePostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Archive Contacts
 */
export const useBulkArchiveContactsApiV1MasterDataContactsPeopleBulkArchivePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof bulkArchiveContactsApiV1MasterDataContactsPeopleBulkArchivePost
          >
        >,
        TError,
        { data: BulkContactRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof bulkArchiveContactsApiV1MasterDataContactsPeopleBulkArchivePost
      >
    >,
    TError,
    { data: BulkContactRequest },
    TContext
  > => {
    const mutationOptions =
      getBulkArchiveContactsApiV1MasterDataContactsPeopleBulkArchivePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Check if a domain is already in use by another company.

Returns:
    - available: True if domain is available, False if already in use
    - company_name: Name of the existing company if domain is in use
 * @summary Check Domain Availability
 */
export const checkDomainAvailabilityApiV1MasterDataContactsOrganizationsCheckDomainPost =
  (checkDomainRequest: CheckDomainRequest, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/organizations/check-domain`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: checkDomainRequest,
      signal
    });
  };

export const getCheckDomainAvailabilityApiV1MasterDataContactsOrganizationsCheckDomainPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof checkDomainAvailabilityApiV1MasterDataContactsOrganizationsCheckDomainPost
        >
      >,
      TError,
      { data: CheckDomainRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof checkDomainAvailabilityApiV1MasterDataContactsOrganizationsCheckDomainPost
      >
    >,
    TError,
    { data: CheckDomainRequest },
    TContext
  > => {
    const mutationKey = [
      'checkDomainAvailabilityApiV1MasterDataContactsOrganizationsCheckDomainPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof checkDomainAvailabilityApiV1MasterDataContactsOrganizationsCheckDomainPost
        >
      >,
      { data: CheckDomainRequest }
    > = (props) => {
      const { data } = props ?? {};

      return checkDomainAvailabilityApiV1MasterDataContactsOrganizationsCheckDomainPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CheckDomainAvailabilityApiV1MasterDataContactsOrganizationsCheckDomainPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof checkDomainAvailabilityApiV1MasterDataContactsOrganizationsCheckDomainPost
      >
    >
  >;
export type CheckDomainAvailabilityApiV1MasterDataContactsOrganizationsCheckDomainPostMutationBody =
  CheckDomainRequest;
export type CheckDomainAvailabilityApiV1MasterDataContactsOrganizationsCheckDomainPostMutationError =
  HTTPValidationError;

/**
 * @summary Check Domain Availability
 */
export const useCheckDomainAvailabilityApiV1MasterDataContactsOrganizationsCheckDomainPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof checkDomainAvailabilityApiV1MasterDataContactsOrganizationsCheckDomainPost
          >
        >,
        TError,
        { data: CheckDomainRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof checkDomainAvailabilityApiV1MasterDataContactsOrganizationsCheckDomainPost
      >
    >,
    TError,
    { data: CheckDomainRequest },
    TContext
  > => {
    const mutationOptions =
      getCheckDomainAvailabilityApiV1MasterDataContactsOrganizationsCheckDomainPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Resolve a free-text query (company name, website, or domain) to one or more candidate companies.

Resolution order:
- The tenant's OWN organizations are searched first (exact domain + fuzzy
  name). Matches are surfaced as candidates carrying ``existing_organization_id``
  so the UI can open the existing record instead of creating a duplicate.
  This resolves tenant-specific companies (e.g. a small "brijlabs" →
  ``brijlabs.ai``) that a general-knowledge LLM cannot know.
- If the query is clearly a domain/URL, returns that single candidate without AI.
- Otherwise AI suggests up to 5 candidates, merged after the tenant matches
  (deduped by domain). When a tenant match is near-exact, the AI call is
  skipped entirely.

Pair with /organizations/enrich-domain to fetch full enrichment for the chosen domain.
 * @summary Company Lookup
 */
export const companyLookupApiV1MasterDataContactsOrganizationsCompanyLookupPost =
  (companyLookupRequest: CompanyLookupRequest, signal?: AbortSignal) => {
    return customInstance<CompanyLookupEnvelope>({
      url: `/api/v1/master-data/contacts/organizations/company-lookup`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: companyLookupRequest,
      signal
    });
  };

export const getCompanyLookupApiV1MasterDataContactsOrganizationsCompanyLookupPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof companyLookupApiV1MasterDataContactsOrganizationsCompanyLookupPost
        >
      >,
      TError,
      { data: CompanyLookupRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof companyLookupApiV1MasterDataContactsOrganizationsCompanyLookupPost
      >
    >,
    TError,
    { data: CompanyLookupRequest },
    TContext
  > => {
    const mutationKey = [
      'companyLookupApiV1MasterDataContactsOrganizationsCompanyLookupPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof companyLookupApiV1MasterDataContactsOrganizationsCompanyLookupPost
        >
      >,
      { data: CompanyLookupRequest }
    > = (props) => {
      const { data } = props ?? {};

      return companyLookupApiV1MasterDataContactsOrganizationsCompanyLookupPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CompanyLookupApiV1MasterDataContactsOrganizationsCompanyLookupPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof companyLookupApiV1MasterDataContactsOrganizationsCompanyLookupPost
      >
    >
  >;
export type CompanyLookupApiV1MasterDataContactsOrganizationsCompanyLookupPostMutationBody =
  CompanyLookupRequest;
export type CompanyLookupApiV1MasterDataContactsOrganizationsCompanyLookupPostMutationError =
  HTTPValidationError;

/**
 * @summary Company Lookup
 */
export const useCompanyLookupApiV1MasterDataContactsOrganizationsCompanyLookupPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof companyLookupApiV1MasterDataContactsOrganizationsCompanyLookupPost
          >
        >,
        TError,
        { data: CompanyLookupRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof companyLookupApiV1MasterDataContactsOrganizationsCompanyLookupPost
      >
    >,
    TError,
    { data: CompanyLookupRequest },
    TContext
  > => {
    const mutationOptions =
      getCompanyLookupApiV1MasterDataContactsOrganizationsCompanyLookupPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Use AI to look up company information from a domain name.

Returns an SSE stream with progress events:
  step=fetching → step=analyzing → step=logo → step=done (with data)

The work itself lives in
:mod:`modules.master_data.contacts.services.domain_enrichment_service` so the
background lane (a connector that just created an organization) can run the
same enrichment without an HTTP request — see that module.
 * @summary Enrich Organization From Domain
 */
export const enrichOrganizationFromDomainApiV1MasterDataContactsOrganizationsEnrichDomainPost =
  (domainEnrichmentRequest: DomainEnrichmentRequest, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/organizations/enrich-domain`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: domainEnrichmentRequest,
      signal
    });
  };

export const getEnrichOrganizationFromDomainApiV1MasterDataContactsOrganizationsEnrichDomainPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof enrichOrganizationFromDomainApiV1MasterDataContactsOrganizationsEnrichDomainPost
        >
      >,
      TError,
      { data: DomainEnrichmentRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof enrichOrganizationFromDomainApiV1MasterDataContactsOrganizationsEnrichDomainPost
      >
    >,
    TError,
    { data: DomainEnrichmentRequest },
    TContext
  > => {
    const mutationKey = [
      'enrichOrganizationFromDomainApiV1MasterDataContactsOrganizationsEnrichDomainPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof enrichOrganizationFromDomainApiV1MasterDataContactsOrganizationsEnrichDomainPost
        >
      >,
      { data: DomainEnrichmentRequest }
    > = (props) => {
      const { data } = props ?? {};

      return enrichOrganizationFromDomainApiV1MasterDataContactsOrganizationsEnrichDomainPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type EnrichOrganizationFromDomainApiV1MasterDataContactsOrganizationsEnrichDomainPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof enrichOrganizationFromDomainApiV1MasterDataContactsOrganizationsEnrichDomainPost
      >
    >
  >;
export type EnrichOrganizationFromDomainApiV1MasterDataContactsOrganizationsEnrichDomainPostMutationBody =
  DomainEnrichmentRequest;
export type EnrichOrganizationFromDomainApiV1MasterDataContactsOrganizationsEnrichDomainPostMutationError =
  HTTPValidationError;

/**
 * @summary Enrich Organization From Domain
 */
export const useEnrichOrganizationFromDomainApiV1MasterDataContactsOrganizationsEnrichDomainPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof enrichOrganizationFromDomainApiV1MasterDataContactsOrganizationsEnrichDomainPost
          >
        >,
        TError,
        { data: DomainEnrichmentRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof enrichOrganizationFromDomainApiV1MasterDataContactsOrganizationsEnrichDomainPost
      >
    >,
    TError,
    { data: DomainEnrichmentRequest },
    TContext
  > => {
    const mutationOptions =
      getEnrichOrganizationFromDomainApiV1MasterDataContactsOrganizationsEnrichDomainPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Auto-fetch and attach a logo for a company based on its domain.

This endpoint looks up the company's domain, tries to find a logo from
Clearbit or favicon, downloads it, and attaches it to the company.
 * @summary Fetch Organization Logo
 */
export const fetchOrganizationLogoApiV1MasterDataContactsOrganizationsOrganizationIdFetchLogoPost =
  (organizationId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/organizations/${organizationId}/fetch-logo`,
      method: 'POST',
      signal
    });
  };

export const getFetchOrganizationLogoApiV1MasterDataContactsOrganizationsOrganizationIdFetchLogoPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof fetchOrganizationLogoApiV1MasterDataContactsOrganizationsOrganizationIdFetchLogoPost
        >
      >,
      TError,
      { organizationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof fetchOrganizationLogoApiV1MasterDataContactsOrganizationsOrganizationIdFetchLogoPost
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationKey = [
      'fetchOrganizationLogoApiV1MasterDataContactsOrganizationsOrganizationIdFetchLogoPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof fetchOrganizationLogoApiV1MasterDataContactsOrganizationsOrganizationIdFetchLogoPost
        >
      >,
      { organizationId: string }
    > = (props) => {
      const { organizationId } = props ?? {};

      return fetchOrganizationLogoApiV1MasterDataContactsOrganizationsOrganizationIdFetchLogoPost(
        organizationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type FetchOrganizationLogoApiV1MasterDataContactsOrganizationsOrganizationIdFetchLogoPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof fetchOrganizationLogoApiV1MasterDataContactsOrganizationsOrganizationIdFetchLogoPost
      >
    >
  >;

export type FetchOrganizationLogoApiV1MasterDataContactsOrganizationsOrganizationIdFetchLogoPostMutationError =
  HTTPValidationError;

/**
 * @summary Fetch Organization Logo
 */
export const useFetchOrganizationLogoApiV1MasterDataContactsOrganizationsOrganizationIdFetchLogoPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof fetchOrganizationLogoApiV1MasterDataContactsOrganizationsOrganizationIdFetchLogoPost
          >
        >,
        TError,
        { organizationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof fetchOrganizationLogoApiV1MasterDataContactsOrganizationsOrganizationIdFetchLogoPost
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationOptions =
      getFetchOrganizationLogoApiV1MasterDataContactsOrganizationsOrganizationIdFetchLogoPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Look up public professional info for one existing contact.

Given the contact's name and its organization's domain/website (and any
stored LinkedIn URL), search the public web and return proposed
business-card fields (job title, department, LinkedIn, city/region/country)
for the user to review and apply. Streams SSE progress:
  step=searching → step=analyzing → step=done (with data)

Single-record, on-request, tenant-scoped (GDPR Posture C); no bulk mode.
 * @summary Enrich Contact From Web
 */
export const enrichContactFromWebApiV1MasterDataContactsPeopleContactIdEnrichPost =
  (
    contactId: string,
    contactEnrichmentRequest: ContactEnrichmentRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/contacts/people/${contactId}/enrich`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: contactEnrichmentRequest,
      signal
    });
  };

export const getEnrichContactFromWebApiV1MasterDataContactsPeopleContactIdEnrichPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof enrichContactFromWebApiV1MasterDataContactsPeopleContactIdEnrichPost
        >
      >,
      TError,
      { contactId: string; data: ContactEnrichmentRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof enrichContactFromWebApiV1MasterDataContactsPeopleContactIdEnrichPost
      >
    >,
    TError,
    { contactId: string; data: ContactEnrichmentRequest },
    TContext
  > => {
    const mutationKey = [
      'enrichContactFromWebApiV1MasterDataContactsPeopleContactIdEnrichPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof enrichContactFromWebApiV1MasterDataContactsPeopleContactIdEnrichPost
        >
      >,
      { contactId: string; data: ContactEnrichmentRequest }
    > = (props) => {
      const { contactId, data } = props ?? {};

      return enrichContactFromWebApiV1MasterDataContactsPeopleContactIdEnrichPost(
        contactId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type EnrichContactFromWebApiV1MasterDataContactsPeopleContactIdEnrichPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof enrichContactFromWebApiV1MasterDataContactsPeopleContactIdEnrichPost
      >
    >
  >;
export type EnrichContactFromWebApiV1MasterDataContactsPeopleContactIdEnrichPostMutationBody =
  ContactEnrichmentRequest;
export type EnrichContactFromWebApiV1MasterDataContactsPeopleContactIdEnrichPostMutationError =
  HTTPValidationError;

/**
 * @summary Enrich Contact From Web
 */
export const useEnrichContactFromWebApiV1MasterDataContactsPeopleContactIdEnrichPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof enrichContactFromWebApiV1MasterDataContactsPeopleContactIdEnrichPost
          >
        >,
        TError,
        { contactId: string; data: ContactEnrichmentRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof enrichContactFromWebApiV1MasterDataContactsPeopleContactIdEnrichPost
      >
    >,
    TError,
    { contactId: string; data: ContactEnrichmentRequest },
    TContext
  > => {
    const mutationOptions =
      getEnrichContactFromWebApiV1MasterDataContactsPeopleContactIdEnrichPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
